<template>
	<div style="cursor: default;">
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>
		<div style="width: 235px;display: flex;flex-direction: column;align-items: center;font-size: 12px;">
			<div style="margin-top: 0px;width: 210px;background-color: #F6F7F9;">
				<div
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 0px;margin: 6px;">
					<div>商品图片宽度占比</div>
					<div
						style="display: flex;align-items: center;margin-left:8px;border: solid 1px; #9f9f9f;padding: 0px 4px;">
						<wm-input-number :iptWidth="40" :disabled="false" :styleObj="{width: '40px',height: '22px'}"
							:step="1" :min="1" :max="100" :value="layoutConfig.left.width"
							@change="(e)=>{changeWidth(e,layoutConfig)}"></wm-input-number>
						<div>%</div>
					</div>
				</div>
				<div
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 15px;margin: 6px;">
					<div>图片与信息块间距</div>
					<div
						style="display: flex;align-items: center;margin-left:8px;border: solid 1px; #9f9f9f;padding: 0px 4px;">
						<wm-input-number :iptWidth="40" :disabled="false" :styleObj="{width: '40px',height: '22px'}"
							:step="1" :min="1" :max="1000000000000" :value="layoutConfig.right.marginLeft"
							@change="(e)=>{layoutConfig.right.marginLeft = e}"></wm-input-number>
						<div>px</div>
					</div>
				</div>
			</div>
		</div>

		<div style="width: 235px;align-items: center;font-size: 12px;display: flex;flex-direction: column;">
			<div style="width: 210px;background-color: #F6F7F9;display: flex;flex-direction: column;">
				<div style="width: 100%;height: 1px;background-color: #c7c7c7;"></div>
				<div style="display: flex;align-items: center;justify-content: space-between;margin: 6px;">
					<div>主图大小</div>
					<div style="display: flex;align-items: center;margin-left:8px;">
						<div @click="mainImgSetType = 'all'"
							:style="{backgroundColor:mainImgSetType == 'all'?'#8c62ff':'#fff',color:mainImgSetType == 'all'?'#fff':'#000',border:mainImgSetType == 'all'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">全局</span>
						</div>
						<div @click="mainImgSetType = 'pc'"
							:style="{backgroundColor:mainImgSetType == 'pc'?'#8c62ff':'#fff',color:mainImgSetType == 'pc'?'#fff':'#000',border:mainImgSetType == 'pc'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">pc端</span>
						</div>
						<div @click="mainImgSetType = 'phone'"
							:style="{backgroundColor:mainImgSetType == 'phone'?'#8c62ff':'#fff',color:mainImgSetType == 'phone'?'#fff':'#000',border:mainImgSetType == 'phone'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">移动端</span>
						</div>
					</div>
				</div>

				<div v-if=""
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;margin: 6px;">
					<div>显示模式</div>
					<div style="display: flex;align-items: center;margin-left:8px;">
						<div @click="layoutConfig.left.percentWidthSwitch = true"
							:style="{backgroundColor:layoutConfig.left.percentWidthSwitch?'#8c62ff':'#fff',color:layoutConfig.left.percentWidthSwitch?'#fff':'#000',border:layoutConfig.left.percentWidthSwitch?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 56px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">裁剪填充</span>
						</div>
						<div @click="layoutConfig.left.percentWidthSwitch = false"
							:style="{backgroundColor:!layoutConfig.left.percentWidthSwitch?'#8c62ff':'#fff',color:!layoutConfig.left.percentWidthSwitch?'#fff':'#000',border:!layoutConfig.left.percentWidthSwitch?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 56px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">原图填充</span>
						</div>
					</div>
				</div>

				<div style="display: flex;align-items: center;align-self: flex-end;margin-top: 10px;">
					<div
						style="display: flex;flex-direction: column;align-items: center;margin-top: 10px;font-size: 12px;">
						<div style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
							<div style="margin-left: 6px;">
								主图宽度
							</div>
							<div>
								<wm-input-number :iptWidth="60" :disabled="false"
									:styleObj="{width: '140px',height: '32px'}" :step="1" :min="1" :max="10000000"
									:value="mainImgSetType != 'phone'? layoutConfig.left.preViewImgWidth : layoutConfig.left.preViewImgPhoneWidth"
									@change="(e)=>{changeMainWidth(e)}"></wm-input-number>
								<!-- <div style="margin-left: 10px;width: 130px;text-align: center;"
									v-if="layoutConfig.left.percentWidthSwitch">
									填充模式宽度100%
								</div> -->
							</div>
						</div>
					</div>
				</div>
				<div style="display: flex;align-items: center;align-self: flex-end;margin-top: 10px;">
					<div
						style="display: flex;flex-direction: column;width: 210px;align-items: center;margin-top: 0px;font-size: 12px;">
						<div style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
							<div style="margin-left: 6px;">
								主图高度
							</div>
							<div>
								<wm-input-number :iptWidth="60" :disabled="false"
									:styleObj="{width: '140px',height: '32px'}" :step="1" :min="1" :max="10000000"
									:value="mainImgSetType != 'phone'? layoutConfig.left.preViewImgHeight : layoutConfig.left.preViewImgPhoneHeight"
									@change="(e)=>{changeMainHeight(e)}"></wm-input-number>
							</div>
						</div>
					</div>
				</div>

				<div
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;margin: 6px;">
					<div>主图边框</div>
					<div style="display: flex;align-items: center;margin-left:8px;">
						<div @click="layoutConfig.left.borderType = ''"
							:style="{backgroundColor:layoutConfig.left.borderType == ''?'#8c62ff':'#fff',color:layoutConfig.left.borderType == ''?'#fff':'#000',border:layoutConfig.left.borderType == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">无</span>
						</div>
						<div @click="layoutConfig.left.borderType = 'solid'"
							:style="{backgroundColor:layoutConfig.left.borderType == 'solid'?'#8c62ff':'#fff',color:layoutConfig.left.borderType == 'solid'?'#fff':'#000',border:layoutConfig.left.borderType == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">实线</span>
						</div>
						<div @click="layoutConfig.left.borderType = 'dashed'"
							:style="{backgroundColor:layoutConfig.left.borderType == 'dashed'?'#8c62ff':'#fff',color:layoutConfig.left.borderType == 'dashed'?'#fff':'#000',border:layoutConfig.left.borderType == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">虚线</span>
						</div>
					</div>
				</div>

				<div
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;margin: 6px;">
					<div>边框颜色</div>
					<div
						style="display: flex;align-items: center;margin-left:8px;background-color: #fff;padding: 2px 4px;">
						<el-color-picker size="small" v-model="layoutConfig.left.borderColor"></el-color-picker>
						<el-input style="width: 84px;margin-left: 6px;" size="mini" placeholder=""
							v-model="layoutConfig.left.borderColor" :disabled="true">
						</el-input>
					</div>
				</div>
				<div style="margin-top: 10px;">
					<div style="margin-left: 6px;">线条大小</div>
					<div
						style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeSize" v-model="layoutConfig.left.borderSize[0]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeSize" v-model="layoutConfig.left.borderSize[1]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeSize" v-model="layoutConfig.left.borderSize[2]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">底部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeSize" v-model="layoutConfig.left.borderSize[3]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
							<i @click="borderSizeAll = !borderSizeAll" :style="{color:borderSizeAll?'#8c62ff':'#000'}"
								style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
								class="el-icon-paperclip tit-icon"></i>
						</div>
					</div>
				</div>

				<div style="margin-top: 10px;">
					<div style="margin-left: 6px;">边框圆角</div>
					<div
						style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeRadius" v-model="layoutConfig.left.borderRadius[0]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">左上</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeRadius" v-model="layoutConfig.left.borderRadius[1]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">右上</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeRadius" v-model="layoutConfig.left.borderRadius[2]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top:2px;color: #424242;scale: 0.85;">右下</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeRadius" v-model="layoutConfig.left.borderRadius[3]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">左下</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;margin-right: 0px;">
							<i @click="boderRadiusAll = !boderRadiusAll"
								:style="{color:boderRadiusAll?'#8c62ff':'#000'}"
								style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
								class="el-icon-paperclip tit-icon"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 235px;display: flex;flex-direction: column;align-items: center;font-size: 12px;">
			<div style="width: 210px;background-color: #F6F7F9;">
				<div style="width: 100%;height: 1px;background-color: #c7c7c7;"></div>
				<div style="display: flex;align-items: center;justify-content: space-between;padding: 6px 0px 6px 0px;">
					<div style="margin-left: 6px;">附属图位置</div>
					<div style="display: flex;align-items: center;margin-right: 6px;">
						<div @click="layoutConfig.left.preViewListPosition = 'left'"
							:style="{backgroundColor:layoutConfig.left.preViewListPosition == 'left'?'#8c62ff':'#fff',color:layoutConfig.left.preViewListPosition == 'left'?'#fff':'#000',border:layoutConfig.left.preViewListPosition == 'left'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">左侧</span>
						</div>
						<div @click="layoutConfig.left.preViewListPosition = 'bottom'"
							:style="{backgroundColor:layoutConfig.left.preViewListPosition == 'bottom'?'#8c62ff':'#fff',color:layoutConfig.left.preViewListPosition == 'bottom'?'#fff':'#000',border:layoutConfig.left.preViewListPosition == 'bottom'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">底部</span>
						</div>
						<div @click="layoutConfig.left.preViewListPosition = 'right'"
							:style="{backgroundColor:layoutConfig.left.preViewListPosition == 'right'?'#8c62ff':'#fff',color:layoutConfig.left.preViewListPosition == 'right'?'#fff':'#000',border:layoutConfig.left.preViewListPosition == 'right'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">右侧</span>
						</div>
					</div>
				</div>
			</div>


			<div style="margin-top: 0px;width: 210px;background-color: #F6F7F9;display: flex;flex-direction: column;">
				<div
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;margin: 6px;">
					<div>附属图大小</div>
					<div style="display: flex;align-items: center;margin-left:8px;">
						<div @click="affiliatedImgType = 'all'"
							:style="{backgroundColor:affiliatedImgType == 'all'?'#8c62ff':'#fff',color:affiliatedImgType == 'all'?'#fff':'#000',border:affiliatedImgType == 'all'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">全部</span>
						</div>
						<div @click="affiliatedImgType = 'pc'"
							:style="{backgroundColor:affiliatedImgType == 'pc'?'#8c62ff':'#fff',color:affiliatedImgType == 'pc'?'#fff':'#000',border:affiliatedImgType == 'pc'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">pc端</span>
						</div>
						<div @click="affiliatedImgType = 'phone'"
							:style="{backgroundColor:affiliatedImgType == 'phone'?'#8c62ff':'#fff',color:affiliatedImgType == 'phone'?'#fff':'#000',border:affiliatedImgType == 'phone'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">移动端</span>
						</div>
					</div>
				</div>
				<!-- <div style="display: flex;align-items: center;align-self: flex-end;margin-top: 10px;">
					<div style="display: flex;align-items: center;width: fit-content;flex-direction: column;">
						<wm-input-number style="border: solid 1px #cecece;" :iptWidth="58" :disabled="false"
							:styleObj="{width: '58px',height: '22px'}" :step="1" :min="1" :max="10000000000"
							:value="affiliatedImgType != 'phone'? layoutConfig.left.preViewListImgWidth : layoutConfig.left.preViewListImgPhoneWidth"
							@change="(e)=>{changeAffiliatedWidth(e)}"></wm-input-number>
						<div style="color: #7a7a7a ;scale: 0.85;">宽度</div>
					</div>
					<div style="display: flex;align-items: center;width: fit-content;flex-direction: column;">
						<wm-input-number style="border: solid 1px #cecece;" :iptWidth="58" :disabled="false"
							:styleObj="{width: '58px',height: '22px'}" :step="1" :min="1" :max="10000000000"
							:value="affiliatedImgType != 'phone'? layoutConfig.left.preViewListImgHeight : layoutConfig.left.preViewListImgPhoneHeight"
							@change="(e)=>{changeAffiliatedHeight(e)}"></wm-input-number>
						<div style="color: #7a7a7a ;scale: 0.85;">高度</div>
					</div>
				</div> -->
				<div v-if="equipment == 'pc'"
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;margin: 6px;">
					<div>显示模式</div>
					<div style="display: flex;align-items: center;margin-left:8px;">
						<div @click="layoutConfig.left.percentrAffiliateWidthSwitch = true"
							:style="{backgroundColor:layoutConfig.left.percentrAffiliateWidthSwitch?'#8c62ff':'#fff',color:layoutConfig.left.percentrAffiliateWidthSwitch?'#fff':'#000',border:layoutConfig.left.percentrAffiliateWidthSwitch?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 56px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">裁剪填充</span>
						</div>
						<div @click="layoutConfig.left.percentrAffiliateWidthSwitch = false"
							:style="{backgroundColor:!layoutConfig.left.percentrAffiliateWidthSwitch?'#8c62ff':'#fff',color:!layoutConfig.left.percentrAffiliateWidthSwitch?'#fff':'#000',border:!layoutConfig.left.percentrAffiliateWidthSwitch?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 56px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">原图填充</span>
						</div>
					</div>
				</div>
				<div style="display: flex;align-items: center;align-self: flex-end;margin-top: 0px;">
					<div
						style="display: flex;flex-direction: column;width: 210px;align-items: center;margin-top: 10px;font-size: 12px;">
						<div style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
							<div style="margin-left: 6px;">
								附属图宽度
							</div>
							<div>
								<wm-input-number :iptWidth="60" :disabled="false"
									:styleObj="{width: '140px',height: '32px'}" :step="1" :min="1" :max="10000000"
									:value="affiliatedImgType != 'phone'? layoutConfig.left.preViewListImgWidth : layoutConfig.left.preViewListImgPhoneWidth"
									@change="(e)=>{changeAffiliatedWidth(e)}"></wm-input-number>
							</div>
						</div>
					</div>
				</div>
				<div style="display: flex;align-items: center;align-self: flex-end;margin-top: 10px;">
					<div
						style="display: flex;flex-direction: column;width: 210px;align-items: center;margin-top: 0px;font-size: 12px;">
						<div style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
							<div style="margin-left: 6px;">
								附属图高度
							</div>
							<div>
								<wm-input-number :iptWidth="60" :disabled="false"
									:styleObj="{width: '140px',height: '32px'}" :step="1" :min="1" :max="10000000"
									:value="affiliatedImgType != 'phone'? layoutConfig.left.preViewListImgHeight : layoutConfig.left.preViewListImgPhoneHeight"
									@change="(e)=>{changeAffiliatedHeight(e)}"></wm-input-number>
							</div>
						</div>
					</div>
				</div>


			</div>
			<div style="width: 210px;background-color: #F6F7F9;display: flex;flex-direction: column;">
				<div style="width: 100%;height: 1px;background-color: #c7c7c7;"></div>
				<div
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;margin: 6px;">
					<div>附属图边框</div>
					<div style="display: flex;align-items: center;margin-left:8px;">
						<div @click="layoutConfig.left.borderAffiliatedType = ''"
							:style="{backgroundColor:layoutConfig.left.borderAffiliatedType == ''?'#8c62ff':'#fff',color:layoutConfig.left.borderAffiliatedType == ''?'#fff':'#000',border:layoutConfig.left.borderAffiliatedType == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">无</span>
						</div>
						<div @click="layoutConfig.left.borderAffiliatedType = 'solid'"
							:style="{backgroundColor:layoutConfig.left.borderAffiliatedType == 'solid'?'#8c62ff':'#fff',color:layoutConfig.left.borderAffiliatedType == 'solid'?'#fff':'#000',border:layoutConfig.left.borderAffiliatedType == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">实线</span>
						</div>
						<div @click="layoutConfig.left.borderAffiliatedType = 'dashed'"
							:style="{backgroundColor:layoutConfig.left.borderAffiliatedType == 'dashed'?'#8c62ff':'#fff',color:layoutConfig.left.borderAffiliatedType == 'dashed'?'#fff':'#000',border:layoutConfig.left.borderAffiliatedType == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">虚线</span>
						</div>
					</div>
				</div>
				<div
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;width: 210px;background-color: #F6F7F9;">
					<div style="margin-left: 6px;">边框颜色</div>
					<div
						style="display: flex;align-items: center;margin-right:6px;background-color: #fff;padding: 2px 4px;">
						<el-color-picker size="small"
							v-model="layoutConfig.left.borderAffiliatedColor"></el-color-picker>
						<el-input style="width: 84px;margin-left: 6px;" size="mini" placeholder=""
							v-model="layoutConfig.left.borderAffiliatedColor" :disabled="true">
						</el-input>
					</div>
				</div>
				<div
					style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;width: 210px;background-color: #F6F7F9;">
					<div style="margin-left: 6px;">边框悬停颜色</div>
					<div
						style="display: flex;align-items: center;margin-right:0px;background-color: #fff;padding: 2px 4px;">
						<el-color-picker size="small"
							v-model="layoutConfig.left.borderAffiliatedHoverColor"></el-color-picker>
						<el-input style="width: 84px;margin-left: 6px;" size="mini" placeholder=""
							v-model="layoutConfig.left.borderAffiliatedHoverColor" :disabled="true">
						</el-input>
					</div>
				</div>
				<div style="margin-top: 10px;">
					<div style="margin-left: 6px;">线条大小</div>
					<div
						style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedSize" v-model="layoutConfig.left.borderAffiliatedSize[0]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedSize" v-model="layoutConfig.left.borderAffiliatedSize[1]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedSize" v-model="layoutConfig.left.borderAffiliatedSize[2]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">底部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedSize" v-model="layoutConfig.left.borderAffiliatedSize[3]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<i @click="borderAffiliatedSizeAll = !borderAffiliatedSizeAll"
								:style="{color:borderAffiliatedSizeAll?'#8c62ff':'#000'}"
								style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
								class="el-icon-paperclip tit-icon"></i>
						</div>
					</div>
				</div>

				<div style="margin-top: 10px;">
					<div style="margin-left: 6px;">边框圆角</div>
					<div
						style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedRadius" v-model="layoutConfig.left.borderAffiliatedRadius[0]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">左上</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedRadius" v-model="layoutConfig.left.borderAffiliatedRadius[1]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">右上</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedRadius" v-model="layoutConfig.left.borderAffiliatedRadius[2]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top:2px;color: #424242;scale: 0.85;">右下</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedRadius" v-model="layoutConfig.left.borderAffiliatedRadius[3]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;color: #424242;scale: 0.85;">左下</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;margin-right: 6px;">
							<i @click="boderAffiliatedRadiusAll = !boderAffiliatedRadiusAll"
								:style="{color:boderAffiliatedRadiusAll?'#8c62ff':'#000'}"
								style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
								class="el-icon-paperclip tit-icon"></i>
						</div>
					</div>
				</div>
			</div>
			<!-- 	<div
				style="margin-top: 0px;width: 210px;background-color: #F6F7F9;padding: 6px;display: flex;flex-direction: column;">
				<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
					<div>附属图边框</div>
					<div style="display: flex;align-items: center;margin-left:8px;">
						<div @click="layoutConfig.left.borderAffiliatedType = ''"
							:style="{backgroundColor:layoutConfig.left.borderAffiliatedType == ''?'#8c62ff':'#fff',color:layoutConfig.left.borderAffiliatedType == ''?'#fff':'#000',border:layoutConfig.left.borderAffiliatedType == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">无</span>
						</div>
						<div @click="layoutConfig.left.borderAffiliatedType = 'solid'"
							:style="{backgroundColor:layoutConfig.left.borderAffiliatedType == 'solid'?'#8c62ff':'#fff',color:layoutConfig.left.borderAffiliatedType == 'solid'?'#fff':'#000',border:layoutConfig.left.borderAffiliatedType == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">实线</span>
						</div>
						<div @click="layoutConfig.left.borderAffiliatedType = 'dashed'"
							:style="{backgroundColor:layoutConfig.left.borderAffiliatedType == 'dashed'?'#8c62ff':'#fff',color:layoutConfig.left.borderAffiliatedType == 'dashed'?'#fff':'#000',border:layoutConfig.left.borderAffiliatedType == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">虚线</span>
						</div>
					</div>
				</div>
				<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
					<div>边框颜色</div>
					<div
						style="display: flex;align-items: center;margin-left:8px;background-color: #fff;padding: 2px 4px;">
						<el-color-picker size="small"
							v-model="layoutConfig.left.borderAffiliatedColor"></el-color-picker>
						<el-input style="width: 84px;margin-left: 6px;" size="mini" placeholder=""
							v-model="layoutConfig.left.borderAffiliatedColor" :disabled="true">
						</el-input>
					</div>
				</div>
				<div style="margin-top: 10px;">
					<div>线条大小</div>
					<div
						style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedSize" v-model="layoutConfig.left.borderAffiliatedSize[0]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">顶部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedSize" v-model="layoutConfig.left.borderAffiliatedSize[1]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">左侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedSize" v-model="layoutConfig.left.borderAffiliatedSize[2]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">底部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedSize" v-model="layoutConfig.left.borderAffiliatedSize[3]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">右侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
							<i @click="borderAffiliatedSizeAll = !borderAffiliatedSizeAll"
								:style="{color:borderAffiliatedSizeAll?'#8c62ff':'#000'}"
								style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
								class="el-icon-paperclip tit-icon"></i>
						</div>
					</div>
				</div>
				<div style="margin-top: 10px;">
					<div>边框圆角</div>
					<div
						style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedRadius" v-model="layoutConfig.left.borderAffiliatedRadius[0]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">顶部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedRadius" v-model="layoutConfig.left.borderAffiliatedRadius[1]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">左侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedRadius" v-model="layoutConfig.left.borderAffiliatedRadius[2]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top:2px;">底部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeAffiliatedRadius" v-model="layoutConfig.left.borderAffiliatedRadius[3]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">右侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
							<i @click="boderAffiliatedRadiusAll = !boderAffiliatedRadiusAll"
								:style="{color:boderAffiliatedRadiusAll?'#8c62ff':'#000'}"
								style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
								class="el-icon-paperclip tit-icon"></i>
						</div>
					</div>
				</div>
			</div> -->
			<div style="width: 235px;display: flex;flex-direction: column;align-items: center;font-size: 12px;">
				<div style="width: 210px;background-color: #F6F7F9;">
					<div style="width: 100%;height: 1px;background-color: #c7c7c7;"></div>
					<div style="display: flex;align-items: center;justify-content: space-between;margin: 6px;">
						<div>主标题位置</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="layoutConfig.right.titlePosition = 'left'"
								:style="{backgroundColor:layoutConfig.right.titlePosition == 'left'?'#8c62ff':'#fff',color:layoutConfig.right.titlePosition == 'left'?'#fff':'#000',border:layoutConfig.right.titlePosition == 'left'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">左侧</span>
							</div>
							<div @click="layoutConfig.right.titlePosition = 'center'"
								:style="{backgroundColor:layoutConfig.right.titlePosition == 'center'?'#8c62ff':'#fff',color:layoutConfig.right.titlePosition == 'center'?'#fff':'#000',border:layoutConfig.right.titlePosition == 'center'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 36px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">居中</span>
							</div>
							<div @click="layoutConfig.right.titlePosition = 'right'"
								:style="{backgroundColor:layoutConfig.right.titlePosition == 'right'?'#8c62ff':'#fff',color:layoutConfig.right.titlePosition == 'right'?'#fff':'#000',border:layoutConfig.right.titlePosition == 'right'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="border: solid 1px #959595;padding: 4px 0px;width: 36px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">右侧</span>
							</div>
						</div>
					</div>
					<div style="margin-top: 10px;">
						<div style="margin-left: 6px;">产品主题样式</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<el-select size="mini" style="width: 130px;" v-model="layoutConfig.right.titleFontFamily"
								placeholder="选择字体">
								<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
									:value="fontItem.name">
								</el-option>
							</el-select>
							<el-color-picker size="mini" v-model="layoutConfig.right.titleColor"
								style="margin-left: 3px;"></el-color-picker>

							<div
								style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
								<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
									:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.titleSize"
									@change="(e)=>{layoutConfig.right.titleSize = e}"></wm-input-number>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div style="width: 235px;display: flex;flex-direction: column;align-items: center;font-size: 12px;">
				<div style="width: 210px;background-color: #F6F7F9;">
					<div style="margin-top: 10px;">
						<div style="margin-left: 6px;">产品特价设置</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<el-select size="mini" v-model="layoutConfig.right.priceFontFamily" placeholder="选择字体">
								<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
									:value="fontItem.name">
								</el-option>
							</el-select>
							<el-color-picker size="mini" v-model="layoutConfig.right.priceColor"
								style="margin-left: 3px;"></el-color-picker>
							<div
								style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
								<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
									:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.priceSize"
									@change="(e)=>{layoutConfig.right.priceSize = e}"></wm-input-number>
							</div>
						</div>
					</div>
					<div style="margin-top: 10px;">
						<div style="margin-left: 6px;">产品原价设置</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<el-select size="mini" style="width: 130px;" v-model="layoutConfig.right.discountFamily"
								placeholder="选择字体">
								<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
									:value="fontItem.name">
								</el-option>
							</el-select>
							<el-color-picker size="mini" v-model="layoutConfig.right.discountColor"
								style="margin-left: 3px;"></el-color-picker>
							<div
								style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
								<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
									:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.discountSize"
									@change="(e)=>{layoutConfig.right.discountSize = e}"></wm-input-number>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div style="width: 235px;display: flex;flex-direction: column;align-items: center;font-size: 12px;">
				<div style="margin-top: 5px;width: 210px;background-color: #F6F7F9;padding: 6px;">
					<div style="margin-top: 10px;">
						<div>产品选项设置</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<el-select size="mini" style="width: 130px;" v-model="layoutConfig.right.optionFamily"
								placeholder="选择字体">
								<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
									:value="fontItem.name">
								</el-option>
							</el-select>
							<el-color-picker size="mini" v-model="layoutConfig.right.optionColor"
								style="margin-left: 3px;"></el-color-picker>
							<div
								style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
								<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
									:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.optionSize"
									@change="(e)=>{layoutConfig.right.optionSize = e}"></wm-input-number>
							</div>
						</div>
					</div>
					<div style="margin-top: 10px;display: flex;justify-content: space-between;align-items: center;">
						<div>是否显示规格图片</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="layoutConfig.right.showSelectImg = true"
								:style="{backgroundColor:layoutConfig.right.showSelectImg ?'#8c62ff':'#fff',color:layoutConfig.right.showSelectImg ?'#fff':'#000',border:layoutConfig.right.showSelectImg ?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">是</span>
							</div>
							<div @click="layoutConfig.right.showSelectImg = false"
								:style="{backgroundColor:!layoutConfig.right.showSelectImg?'#8c62ff':'#fff',color:!layoutConfig.right.showSelectImg?'#fff':'#000',border:!layoutConfig.right.showSelectImg ?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">否</span>
							</div>
						</div>
					</div>
					<div v-if=""
						style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;margin: 0px;">
						<div style="margin-top: 10px;">显示模式</div>
						
						<div style="display: flex;align-items: center;margin-left:8px;margin-top: 10px;">
							<div @click="layoutConfig.right.showSelectImgSet.mode = 'cover'"
								:style="{backgroundColor:layoutConfig.right.showSelectImgSet.mode == 'cover'?'#8c62ff':'#fff',color:layoutConfig.right.showSelectImgSet.mode == 'cover'?'#fff':'#000',border:layoutConfig.right.showSelectImgSet.mode == 'cover'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 56px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">裁剪填充</span>
							</div>
							<div @click="layoutConfig.right.showSelectImgSet.mode = 'contain'"
								:style="{backgroundColor:layoutConfig.right.showSelectImgSet.mode == 'contain'?'#8c62ff':'#fff',color:layoutConfig.right.showSelectImgSet.mode == 'contain'?'#fff':'#000',border:layoutConfig.right.showSelectImgSet.mode == 'contain'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 56px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">原图填充</span>
							</div>
						</div>
					</div>
					
					<div style="display: flex;align-items: center;align-self: flex-end;margin-top: 10px;">
						<div
							style="display: flex;flex-direction: column;align-items: center;margin-top: 10px;font-size: 12px;">
							<div style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
								<div style="margin-left: 6px;">
									规格图宽度
								</div>
								<div>
									<wm-input-number :iptWidth="60" :disabled="false"
										:styleObj="{width: '140px',height: '32px'}" :step="1" :min="1" :max="10000000"
										:value="equipment != 'phone'? layoutConfig.right.showSelectImgSet.width : layoutConfig.right.showSelectImgSet.phoneWidth"
										@change="(e)=>{equipment != 'phone'?layoutConfig.right.showSelectImgSet.width = e:layoutConfig.right.showSelectImgSet.phoneWidth = e}"></wm-input-number>
								</div>
							</div>
						</div>
					</div>
					<div style="display: flex;align-items: center;align-self: flex-end;margin-top: 10px;">
						<div
							style="display: flex;flex-direction: column;width: 210px;align-items: center;margin-top: 0px;font-size: 12px;">
							<div style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
								<div style="margin-left: 6px;">
									规格图高度
								</div>
								<div>
									<wm-input-number :iptWidth="60" :disabled="false"
										:styleObj="{width: '140px',height: '32px'}" :step="1" :min="1" :max="10000000"
										:value="equipment != 'phone'? layoutConfig.right.showSelectImgSet.height : layoutConfig.right.showSelectImgSet.phoneHeight"
										@change="(e)=>{equipment != 'phone'?layoutConfig.right.showSelectImgSet.height = e:layoutConfig.right.showSelectImgSet.phoneHeight = e}"></wm-input-number>
								</div>
							</div>
						</div>
					</div>
					
					<!-- <div style="margin-top:10px;">
						<div>边框圆角</div>
						<div
							style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionImgBorderRadius"
									v-model="layoutConfig.right.selectImgBorderRadius[0]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">左上</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionImgBorderRadius"
									v-model="layoutConfig.right.selectImgBorderRadius[1]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">右上</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionImgBorderRadius"
									v-model="layoutConfig.right.selectImgBorderRadius[2]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top:2px;color: #424242;scale: 0.85;">右下</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionImgBorderRadius"
									v-model="layoutConfig.right.selectImgBorderRadius[3]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">左下</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;margin-right: 4px;">
								<i @click="selectImgBorderRadiusAll = !selectImgBorderRadiusAll"
									:style="{color:selectImgBorderRadiusAll?'#8c62ff':'#000'}"
									style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
									class="el-icon-paperclip tit-icon"></i>
							</div>
						</div>
					</div> -->
					
					<div style="margin-top: 15px;display: flex;justify-content: space-between;align-items: center;">
						<div>选项背景</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="layoutConfig.right.isHover = false"
								:style="{backgroundColor:!layoutConfig.right.isHover?'#8c62ff':'#fff',color:!layoutConfig.right.isHover?'#fff':'#000',border:!layoutConfig.right.isHover?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">默认</span>
							</div>
							<div @click="layoutConfig.right.isHover = true"
								:style="{backgroundColor:layoutConfig.right.isHover?'#8c62ff':'#fff',color:layoutConfig.right.isHover?'#fff':'#000',border:layoutConfig.right.isHover?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">悬停</span>
							</div>
						</div>
					</div>


					<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
						<div>默认字体颜色</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<el-color-picker size="mini" v-model="layoutConfig.right.selectTabSet.defaultBg.fontColor"
								style="margin-left: 3px;"></el-color-picker>
						</div>
					</div>

					<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
						<div>默认背景设置</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="layoutConfig.right.selectTabSet.defaultBg.bgtype = 'color'"
								:style="{backgroundColor:layoutConfig.right.selectTabSet.defaultBg.bgtype == 'color'?'#8c62ff':'#fff',color:layoutConfig.right.selectTabSet.defaultBg.bgtype == 'color'?'#fff':'#000',border:layoutConfig.right.selectTabSet.defaultBg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">纯色</span>
							</div>
							<div @click="layoutConfig.right.selectTabSet.defaultBg.bgtype = 'gradient'"
								:style="{backgroundColor:layoutConfig.right.selectTabSet.defaultBg.bgtype == 'gradient'?'#8c62ff':'#fff',color:layoutConfig.right.selectTabSet.defaultBg.bgtype == 'gradient'?'#fff':'#000',border:layoutConfig.right.selectTabSet.defaultBg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">渐变</span>
							</div>
						</div>
					</div>

					<div>
						<div v-if="layoutConfig.right.selectTabSet.defaultBg.bgtype== 'color'"
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
							<div style="width: 68px;">
								背景颜色:
							</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.selectTabSet.defaultBg.color"></el-color-picker>
						</div>
						<div v-if="layoutConfig.right.selectTabSet.defaultBg.bgtype == 'gradient'"
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
							<div
								style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
								<div style="display: flex;flex-direction: column;">
									<div style="display: flex;align-items: center;">
									</div>
									<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
										placeholder="请输入内容"
										v-model="layoutConfig.right.selectTabSet.defaultBg.bgGradient">
									</el-input>
								</div>
								<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
									需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
										href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
										target="_blank" href="https://webgradients.com/">Gradient2</a>
								</div>
							</div>
						</div>
					</div>




					<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
						<div>选中字体颜色</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<el-color-picker size="mini" v-model="layoutConfig.right.selectTabSet.selectBg.fontColor"
								style="margin-left: 3px;"></el-color-picker>
						</div>
					</div>

					<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
						<div>选中背景</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="layoutConfig.right.selectTabSet.selectBg.bgtype = 'color'"
								:style="{backgroundColor:layoutConfig.right.selectTabSet.selectBg.bgtype == 'color'?'#8c62ff':'#fff',color:layoutConfig.right.selectTabSet.selectBg.bgtype == 'color'?'#fff':'#000',border:layoutConfig.right.selectTabSet.selectBg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">纯色</span>
							</div>
							<div @click="layoutConfig.right.selectTabSet.selectBg.bgtype = 'gradient'"
								:style="{backgroundColor:layoutConfig.right.selectTabSet.selectBg.bgtype == 'gradient'?'#8c62ff':'#fff',color:layoutConfig.right.selectTabSet.selectBg.bgtype == 'gradient'?'#fff':'#000',border:layoutConfig.right.selectTabSet.selectBg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">渐变</span>
							</div>
						</div>
					</div>

					<div>
						<div v-if="layoutConfig.right.selectTabSet.selectBg.bgtype== 'color'"
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
							<div style="width: 68px;">
								背景颜色:
							</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.selectTabSet.selectBg.color"></el-color-picker>
						</div>
						<div v-if="layoutConfig.right.selectTabSet.selectBg.bgtype == 'gradient'"
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
							<div
								style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
								<div style="display: flex;flex-direction: column;">
									<div style="display: flex;align-items: center;">
									</div>
									<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
										placeholder="请输入内容"
										v-model="layoutConfig.right.selectTabSet.selectBg.bgGradient">
									</el-input>
								</div>
								<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
									需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
										href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
										target="_blank" href="https://webgradients.com/">Gradient2</a>
								</div>
							</div>
						</div>
					</div>

					<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
						<div>悬停字体颜色</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<el-color-picker size="mini" v-model="layoutConfig.right.selectTabSet.hoverBg.fontColor"
								style="margin-left: 3px;"></el-color-picker>
						</div>
					</div>

					<div v-if="layoutConfig.right.isHover"
						style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
						<div>悬停背景</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="layoutConfig.right.selectTabSet.hoverBg.bgtype = 'color'"
								:style="{backgroundColor:layoutConfig.right.selectTabSet.hoverBg.bgtype == 'color'?'#8c62ff':'#fff',color:layoutConfig.right.selectTabSet.hoverBg.bgtype == 'color'?'#fff':'#000',border:layoutConfig.right.selectTabSet.hoverBg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">纯色</span>
							</div>
							<div @click="layoutConfig.right.selectTabSet.hoverBg.bgtype = 'gradient'"
								:style="{backgroundColor:layoutConfig.right.selectTabSet.hoverBg.bgtype == 'gradient'?'#8c62ff':'#fff',color:layoutConfig.right.selectTabSet.hoverBg.bgtype == 'gradient'?'#fff':'#000',border:layoutConfig.right.selectTabSet.hoverBg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">渐变</span>
							</div>
						</div>
					</div>

					<div v-if="layoutConfig.right.isHover">
						<div v-if="layoutConfig.right.selectTabSet.hoverBg.bgtype== 'color'"
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
							<div style="width: 68px;">
								背景颜色:
							</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.selectTabSet.hoverBg.color"></el-color-picker>
						</div>
						<div v-if="layoutConfig.right.selectTabSet.hoverBg.bgtype == 'gradient'"
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
							<div
								style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
								<div style="display: flex;flex-direction: column;">
									<div style="display: flex;align-items: center;">
									</div>
									<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
										placeholder="请输入内容"
										v-model="layoutConfig.right.selectTabSet.hoverBg.bgGradient">
									</el-input>
								</div>
								<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
									需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
										href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
										target="_blank" href="https://webgradients.com/">Gradient2</a>
								</div>
							</div>
						</div>
					</div>



					<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
						<div>边框设置</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="layoutConfig.right.optionBorderType = ''"
								:style="{backgroundColor:layoutConfig.right.optionBorderType == ''?'#8c62ff':'#fff',color:layoutConfig.right.optionBorderType == ''?'#fff':'#000',border:layoutConfig.right.optionBorderType == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">无</span>
							</div>
							<div @click="layoutConfig.right.optionBorderType = 'solid'"
								:style="{backgroundColor:layoutConfig.right.optionBorderType == 'solid'?'#8c62ff':'#fff',color:layoutConfig.right.optionBorderType == 'solid'?'#fff':'#000',border:layoutConfig.right.optionBorderType == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">实线</span>
							</div>
							<div @click="layoutConfig.right.optionBorderType = 'dashed'"
								:style="{backgroundColor:layoutConfig.right.optionBorderType == 'dashed'?'#8c62ff':'#fff',color:layoutConfig.right.optionBorderType == 'dashed'?'#fff':'#000',border:layoutConfig.right.optionBorderType == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">虚线</span>
							</div>
						</div>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
						<div> </div>
						<div
							style="display: flex;align-items: center;margin-left:8px;background-color: #fff;padding: 2px 4px;">
							<el-color-picker size="small"
								v-model="layoutConfig.right.optionBorderColor"></el-color-picker>
							<el-input style="width: 84px;margin-left: 6px;" size="mini" placeholder=""
								v-model="layoutConfig.right.optionBorderColor" :disabled="true">
							</el-input>
						</div>
					</div>

					<div v-if="layoutConfig.right.isHover"
						style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
						<div>悬停边框颜色</div>
						<div style="display: flex;align-items: center;margin-left:8px;">
							<div @click="layoutConfig.right.hoverBorderType = ''"
								:style="{backgroundColor:layoutConfig.right.hoverBorderType == ''?'#8c62ff':'#fff',color:layoutConfig.right.hoverBorderType == ''?'#fff':'#000',border:layoutConfig.right.hoverBorderType == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">无</span>
							</div>
							<div @click="layoutConfig.right.hoverBorderType = 'solid'"
								:style="{backgroundColor:layoutConfig.right.hoverBorderType == 'solid'?'#8c62ff':'#fff',color:layoutConfig.right.hoverBorderType == 'solid'?'#fff':'#000',border:layoutConfig.right.hoverBorderType == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">实线</span>
							</div>
							<div @click="layoutConfig.right.hoverBorderType = 'dashed'"
								:style="{backgroundColor:layoutConfig.right.hoverBorderType == 'dashed'?'#8c62ff':'#fff',color:layoutConfig.right.hoverBorderType == 'dashed'?'#fff':'#000',border:layoutConfig.right.hoverBorderType == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">虚线</span>
							</div>
						</div>
					</div>
					<div v-if="layoutConfig.right.isHover"
						style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
						<div> </div>
						<div
							style="display: flex;align-items: center;margin-left:8px;background-color: #fff;padding: 2px 4px;">
							<el-color-picker size="small"
								v-model="layoutConfig.right.hoverBorderColor"></el-color-picker>
							<el-input style="width: 84px;margin-left: 6px;" size="mini" placeholder=""
								v-model="layoutConfig.right.hoverBorderColor" :disabled="true">
							</el-input>
						</div>
					</div>
					<div style="margin-top: 10px;">
						<div>线条大小</div>
						<div
							style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionBorderSize" v-model="layoutConfig.right.optionBorderSize[0]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionBorderSize" v-model="layoutConfig.right.optionBorderSize[1]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionBorderSize" v-model="layoutConfig.right.optionBorderSize[2]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">底部</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionBorderSize" v-model="layoutConfig.right.optionBorderSize[3]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
								<i @click="optionBorderSizeAll = !optionBorderSizeAll"
									:style="{color:optionBorderSizeAll?'#8c62ff':'#000'}"
									style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
									class="el-icon-paperclip tit-icon"></i>
							</div>
						</div>
					</div>
					<div style="margin-top: 10px;">
						<div>边框圆角</div>
						<div
							style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionBorderRadius"
									v-model="layoutConfig.right.optionBorderRadius[0]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">左上</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionBorderRadius"
									v-model="layoutConfig.right.optionBorderRadius[1]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">右上</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionBorderRadius"
									v-model="layoutConfig.right.optionBorderRadius[2]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top:2px;color: #424242;scale: 0.85;">右下</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeoptionBorderRadius"
									v-model="layoutConfig.right.optionBorderRadius[3]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;color: #424242;scale: 0.85;">左下</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;margin-right: 4px;">
								<i @click="optionBorderRadiusAll = !optionBorderRadiusAll"
									:style="{color:optionBorderRadiusAll?'#8c62ff':'#000'}"
									style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
									class="el-icon-paperclip tit-icon"></i>
							</div>
						</div>
					</div>
				</div>

			</div>


			<div style="width: 235px;display: flex;flex-direction: column;align-items: center;font-size: 12px;">
				<div style="width: 210px;background-color: #F6F7F9;">
					<div style="width: 100%;height: 1px;background-color: #c7c7c7;"></div>
					<div style="width: 210px;padding: 6px;">
						<div style="margin-top: 10px;">
							<div>其他信息设置(库存/SKU/品牌信息)</div>
						</div>
						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>价格</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.priceShow.price = true"
									:style="{backgroundColor:layoutConfig.right.priceShow.price?'#8c62ff':'#fff',color:layoutConfig.right.priceShow.price?'#fff':'#000',border:layoutConfig.right.priceShow.price?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.priceShow.price = false"
									:style="{backgroundColor:!layoutConfig.right.priceShow.price?'#8c62ff':'#fff',color:!layoutConfig.right.priceShow.price?'#fff':'#000',border:!layoutConfig.right.priceShow.price?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>

						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>原价</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.priceShow.originalPrice = true"
									:style="{backgroundColor:layoutConfig.right.priceShow.originalPrice?'#8c62ff':'#fff',color:layoutConfig.right.priceShow.originalPrice?'#fff':'#000',border:layoutConfig.right.priceShow.originalPrice?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.priceShow.originalPrice = false"
									:style="{backgroundColor:!layoutConfig.right.priceShow.originalPrice?'#8c62ff':'#fff',color:!layoutConfig.right.priceShow.originalPrice?'#fff':'#000',border:!layoutConfig.right.priceShow.originalPrice?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>


						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>库存</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showInventory = true"
									:style="{backgroundColor:layoutConfig.right.showInventory?'#8c62ff':'#fff',color:layoutConfig.right.showInventory?'#fff':'#000',border:layoutConfig.right.showInventory?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showInventory = false"
									:style="{backgroundColor:!layoutConfig.right.showInventory?'#8c62ff':'#fff',color:!layoutConfig.right.showInventory?'#fff':'#000',border:!layoutConfig.right.showInventory?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>
						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								标题
							</div>
							<div style="display: flex;align-items: center;">
								<el-color-picker size="mini" v-model="layoutConfig.right.quantityFont.color"
									style="margin-left: 3px;"></el-color-picker>
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.quantityFont.fontSize"
										@change="(e)=>{layoutConfig.right.quantityFont.fontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>
						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								内容
							</div>
							<div style="display: flex;align-items: center;">
								<el-color-picker size="mini" v-model="layoutConfig.right.quantityFont.titColor"
									style="margin-left: 3px;"></el-color-picker>
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.quantityFont.titFontSize"
										@change="(e)=>{layoutConfig.right.quantityFont.titFontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>




						<div style="display: flex;justify-content: space-between;margin-top: 20px;width: 198px;">
							<div>品牌</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showBrand = true"
									:style="{backgroundColor:layoutConfig.right.showBrand?'#8c62ff':'#fff',color:layoutConfig.right.showBrand?'#fff':'#000',border:layoutConfig.right.showBrand?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showBrand = false"
									:style="{backgroundColor:!layoutConfig.right.showBrand?'#8c62ff':'#fff',color:!layoutConfig.right.showBrand?'#fff':'#000',border:!layoutConfig.right.showBrand?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>

						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								标题
							</div>
							<div style="display: flex;align-items: center;">
								<el-color-picker size="mini" v-model="layoutConfig.right.brandFont.color"
									style="margin-left: 3px;"></el-color-picker>
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.brandFont.fontSize"
										@change="(e)=>{layoutConfig.right.brandFont.fontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>

						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								内容
							</div>
							<div style="display: flex;align-items: center;">
								<el-color-picker size="mini" v-model="layoutConfig.right.brandFont.titColor"
									style="margin-left: 3px;"></el-color-picker>
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.brandFont.titFontSize"
										@change="(e)=>{layoutConfig.right.brandFont.titFontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>

						<div style="display: flex;justify-content: space-between;margin-top: 20px;width: 198px;">
							<div>SKU</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showSKU = true"
									:style="{backgroundColor:layoutConfig.right.showSKU?'#8c62ff':'#fff',color:layoutConfig.right.showSKU?'#fff':'#000',border:layoutConfig.right.showSKU?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showSKU = false"
									:style="{backgroundColor:!layoutConfig.right.showSKU?'#8c62ff':'#fff',color:!layoutConfig.right.showSKU?'#fff':'#000',border:!layoutConfig.right.showSKU?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>

						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								标题
							</div>
							<div style="display: flex;align-items: center;">
								<el-color-picker size="mini" v-model="layoutConfig.right.skuFont.color"
									style="margin-left: 3px;"></el-color-picker>
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.skuFont.fontSize"
										@change="(e)=>{layoutConfig.right.skuFont.fontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>

						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								内容
							</div>
							<div style="display: flex;align-items: center;">
								<el-color-picker size="mini" v-model="layoutConfig.right.skuFont.titColor"
									style="margin-left: 3px;"></el-color-picker>
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.skuFont.titFontSize"
										@change="(e)=>{layoutConfig.right.skuFont.titFontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>

						<div style="display: flex;justify-content: space-between;margin-top: 20px;width: 198px;">
							<div>型号</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showSize = true"
									:style="{backgroundColor:layoutConfig.right.showSize?'#8c62ff':'#fff',color:layoutConfig.right.showSize?'#fff':'#000',border:layoutConfig.right.showSize?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showSize = false"
									:style="{backgroundColor:!layoutConfig.right.showSize?'#8c62ff':'#fff',color:!layoutConfig.right.showSize?'#fff':'#000',border:!layoutConfig.right.showSize?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>

						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								标题
							</div>
							<div style="display: flex;align-items: center;">
								<el-color-picker size="mini" v-model="layoutConfig.right.modelFont.color"
									style="margin-left: 3px;"></el-color-picker>
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.modelFont.fontSize"
										@change="(e)=>{layoutConfig.right.modelFont.fontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>

						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								内容
							</div>
							<div style="display: flex;align-items: center;">
								<el-color-picker size="mini" v-model="layoutConfig.right.modelFont.titColor"
									style="margin-left: 3px;"></el-color-picker>
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.modelFont.titFontSize"
										@change="(e)=>{layoutConfig.right.modelFont.titFontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div style="width: 235px;display: flex;flex-direction: column;align-items: center;font-size: 12px;">
				<div style="width: 210px;background-color: #F6F7F9;">
					<div style="width: 100%;height: 1px;background-color: #c7c7c7;"></div>
					<div style="width: 210px;padding: 6px;">
						<div style="margin-top: 10px;">
							<div>按钮设置</div>
						</div>
						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>产品数量</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showAddNum = true"
									:style="{backgroundColor:layoutConfig.right.showAddNum?'#8c62ff':'#fff',color:layoutConfig.right.showAddNum?'#fff':'#000',border:layoutConfig.right.showAddNum?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showAddNum = false"
									:style="{backgroundColor:!layoutConfig.right.showAddNum?'#8c62ff':'#fff',color:!layoutConfig.right.showAddNum?'#fff':'#000',border:!layoutConfig.right.showAddNum?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>

						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>独占一行</div>
							<div style="display: flex;align-items: center;">
								<div @click="setRetf(layoutConfig.right.rightBtn,'addNumFull','phoneAddNumFull',true)"
									:style="{backgroundColor:retf(layoutConfig.right.rightBtn,'addNumFull','phoneAddNumFull')?'#8c62ff':'#fff',color:retf(layoutConfig.right.rightBtn,'addNumFull','phoneAddNumFull')?'#fff':'#000',border:retf(layoutConfig.right.rightBtn,'addNumFull','phoneAddNumFull')?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">是</span>
								</div>
								<div @click="setRetf(layoutConfig.right.rightBtn,'addNumFull','phoneAddNumFull',false)"
									:style="{backgroundColor:!retf(layoutConfig.right.rightBtn,'addNumFull','phoneAddNumFull')?'#8c62ff':'#fff',color:!retf(layoutConfig.right.rightBtn,'addNumFull','phoneAddNumFull')?'#fff':'#000',border:!retf(layoutConfig.right.rightBtn,'addNumFull','phoneAddNumFull')?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">否</span>
								</div>
							</div>
						</div>

						<div
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;margin-top: 30px;">
							<div>加入购物车</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showAddCart = true"
									:style="{backgroundColor:layoutConfig.right.showAddCart?'#8c62ff':'#fff',color:layoutConfig.right.showAddCart?'#fff':'#000',border:layoutConfig.right.showAddCart?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showAddCart = false"
									:style="{backgroundColor:!layoutConfig.right.showAddCart?'#8c62ff':'#fff',color:!layoutConfig.right.showAddCart?'#fff':'#000',border:!layoutConfig.right.showAddCart?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>








						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>独占一行</div>
							<div style="display: flex;align-items: center;">
								<div @click="setRetf(layoutConfig.right.rightBtn,'addCartFull','phoneAddCartFull',true)"
									:style="{backgroundColor:retf(layoutConfig.right.rightBtn,'addCartFull','phoneAddCartFull')?'#8c62ff':'#fff',color:retf(layoutConfig.right.rightBtn,'addCartFull','phoneAddCartFull')?'#fff':'#000',border:retf(layoutConfig.right.rightBtn,'addCartFull','phoneAddCartFull')?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">是</span>
								</div>
								<div @click="setRetf(layoutConfig.right.rightBtn,'addCartFull','phoneAddCartFull',false)"
									:style="{backgroundColor:!retf(layoutConfig.right.rightBtn,'addCartFull','phoneAddCartFull')?'#8c62ff':'#fff',color:!retf(layoutConfig.right.rightBtn,'addCartFull','phoneAddCartFull')?'#fff':'#000',border:!retf(layoutConfig.right.rightBtn,'addCartFull','phoneAddCartFull')?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">否</span>
								</div>
							</div>
						</div>

						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>字体颜色</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.rightBtnColor.addCart.color"></el-color-picker>
						</div>

						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>边框颜色</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.rightBtnColor.addCart.border.color"></el-color-picker>
						</div>


						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>背景设置</div>
							<div style="display: flex;align-items: center;margin-left:8px;">
								<div @click="layoutConfig.right.rightBtnColor.addCart.bg.bgtype = 'color'"
									:style="{backgroundColor:layoutConfig.right.rightBtnColor.addCart.bg.bgtype == 'color'?'#8c62ff':'#fff',color:layoutConfig.right.rightBtnColor.addCart.bg.bgtype == 'color'?'#fff':'#000',border:layoutConfig.right.rightBtnColor.addCart.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">纯色</span>
								</div>
								<div @click="layoutConfig.right.rightBtnColor.addCart.bg.bgtype = 'gradient'"
									:style="{backgroundColor:layoutConfig.right.rightBtnColor.addCart.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:layoutConfig.right.rightBtnColor.addCart.bg.bgtype == 'gradient'?'#fff':'#000',border:layoutConfig.right.rightBtnColor.addCart.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">渐变</span>
								</div>
							</div>
						</div>
						<div>
							<div v-if="layoutConfig.right.rightBtnColor.addCart.bg.bgtype == 'color'"
								style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
								<div style="width: 68px;">
									背景颜色:
								</div>
								<el-color-picker size="mini"
									v-model="layoutConfig.right.rightBtnColor.addCart.bg.color"></el-color-picker>
							</div>
							<div v-if="layoutConfig.right.rightBtnColor.addCart.bg.bgtype == 'gradient'"
								style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
								<div
									style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
									<div style="display: flex;flex-direction: column;">
										<div style="display: flex;align-items: center;">
										</div>
										<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
											placeholder="请输入内容"
											v-model="layoutConfig.right.rightBtnColor.addCart.bg.bgGradient">
										</el-input>
									</div>
									<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
										需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
											href="https://www.eggradients.com/">Gradient1</a> <a
											style="margin-left: 4px;" target="_blank"
											href="https://webgradients.com/">Gradient2</a>
									</div>
								</div>
							</div>
						</div>

						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;align-items: center;">
							<div>加入购物车宽度</div>
							<div style="display: flex;align-items: center;">
								<wm-input-number :iptWidth="60" :disabled="false"
									:styleObj="{width: '100px',height: '32px'}" :step="1" :min="1" :max="10000000"
									:value="equipment == 'pc'? layoutConfig.right.rightBtn.addCartWidth : layoutConfig.right.rightBtn.phoneAddCartWidth"
									@change="(e)=>{equipment == 'pc'?layoutConfig.right.rightBtn.addCartWidth = e:layoutConfig.right.rightBtn.phoneAddCartWidth = e}"></wm-input-number>
							</div>
						</div>



						<div
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;margin-top: 30px;">
							<div>立即购买</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showBuyNow = true"
									:style="{backgroundColor:layoutConfig.right.showBuyNow?'#8c62ff':'#fff',color:layoutConfig.right.showBuyNow?'#fff':'#000',border:layoutConfig.right.showBuyNow?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showBuyNow = false"
									:style="{backgroundColor:!layoutConfig.right.showBuyNow?'#8c62ff':'#fff',color:!layoutConfig.right.showBuyNow?'#fff':'#000',border:!layoutConfig.right.showBuyNow?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>



						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>独占一行</div>
							<div style="display: flex;align-items: center;">
								<div @click="setRetf(layoutConfig.right.rightBtn,'buyNowFull','phoneBuyNowFull',true)"
									:style="{backgroundColor:retf(layoutConfig.right.rightBtn,'buyNowFull','phoneBuyNowFull')?'#8c62ff':'#fff',color:retf(layoutConfig.right.rightBtn,'buyNowFull','phoneBuyNowFull')?'#fff':'#000',border:retf(layoutConfig.right.rightBtn,'buyNowFull','phoneBuyNowFull')?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">是</span>
								</div>
								<div @click="setRetf(layoutConfig.right.rightBtn,'buyNowFull','phoneBuyNowFull',false)"
									:style="{backgroundColor:!retf(layoutConfig.right.rightBtn,'buyNowFull','phoneBuyNowFull')?'#8c62ff':'#fff',color:!retf(layoutConfig.right.rightBtn,'buyNowFull','phoneBuyNowFull')?'#fff':'#000',border:!retf(layoutConfig.right.rightBtn,'buyNowFull','phoneBuyNowFull')?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">否</span>
								</div>
							</div>
						</div>


						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>字体颜色</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.rightBtnColor.buyNow.color"></el-color-picker>
						</div>

						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>边框颜色</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.rightBtnColor.buyNow.border.color"></el-color-picker>
						</div>

						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>背景设置</div>
							<div style="display: flex;align-items: center;margin-left:8px;">
								<div @click="layoutConfig.right.rightBtnColor.buyNow.bg.bgtype = 'color'"
									:style="{backgroundColor:layoutConfig.right.rightBtnColor.buyNow.bg.bgtype == 'color'?'#8c62ff':'#fff',color:layoutConfig.right.rightBtnColor.buyNow.bg.bgtype == 'color'?'#fff':'#000',border:layoutConfig.right.rightBtnColor.buyNow.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">纯色</span>
								</div>
								<div @click="layoutConfig.right.rightBtnColor.buyNow.bg.bgtype = 'gradient'"
									:style="{backgroundColor:layoutConfig.right.rightBtnColor.buyNow.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:layoutConfig.right.rightBtnColor.buyNow.bg.bgtype == 'gradient'?'#fff':'#000',border:layoutConfig.right.rightBtnColor.buyNow.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">渐变</span>
								</div>
							</div>
						</div>
						<div>
							<div v-if="layoutConfig.right.rightBtnColor.buyNow.bg.bgtype == 'color'"
								style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
								<div style="width: 68px;">
									背景颜色:
								</div>
								<el-color-picker size="mini"
									v-model="layoutConfig.right.rightBtnColor.buyNow.bg.color"></el-color-picker>
							</div>
							<div v-if="layoutConfig.right.rightBtnColor.buyNow.bg.bgtype == 'gradient'"
								style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
								<div
									style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
									<div style="display: flex;flex-direction: column;">
										<div style="display: flex;align-items: center;">
										</div>
										<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
											placeholder="请输入内容"
											v-model="layoutConfig.right.rightBtnColor.buyNow.bg.bgGradient">
										</el-input>
									</div>
									<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
										需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
											href="https://www.eggradients.com/">Gradient1</a> <a
											style="margin-left: 4px;" target="_blank"
											href="https://webgradients.com/">Gradient2</a>
									</div>
								</div>
							</div>
						</div>

						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;align-items: center;">
							<div>立即购买宽度</div>
							<div style="display: flex;align-items: center;">
								<wm-input-number :iptWidth="60" :disabled="false"
									:styleObj="{width: '100px',height: '32px'}" :step="1" :min="1" :max="10000000"
									:value="equipment == 'pc'? layoutConfig.right.rightBtn.buyNowWidth : layoutConfig.right.rightBtn.phoneBuyNowWidth"
									@change="(e)=>{equipment == 'pc'?layoutConfig.right.rightBtn.buyNowWidth = e:layoutConfig.right.rightBtn.phoneBuyNowWidth = e}"></wm-input-number>
							</div>
						</div>



						<div
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;margin-top: 30px;">
							<div>收藏</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showLove = true"
									:style="{backgroundColor:layoutConfig.right.showLove?'#8c62ff':'#fff',color:layoutConfig.right.showLove?'#fff':'#000',border:layoutConfig.right.showLove?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showLove = false"
									:style="{backgroundColor:!layoutConfig.right.showLove?'#8c62ff':'#fff',color:!layoutConfig.right.showLove?'#fff':'#000',border:!layoutConfig.right.showLove?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>
						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>背景颜色</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.rightBtnColor.love.bg.color"></el-color-picker>
						</div>


						<div v-if="layoutConfig.right.rightBtn"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>独占一行</div>
							<div style="display: flex;align-items: center;">
								<div @click="setRetf(layoutConfig.right.rightBtn,'loveFull','phoneLoveFull',true)"
									:style="{backgroundColor:retf(layoutConfig.right.rightBtn,'loveFull','phoneLoveFull')?'#8c62ff':'#fff',color:retf(layoutConfig.right.rightBtn,'loveFull','phoneLoveFull')?'#fff':'#000',border:retf(layoutConfig.right.rightBtn,'loveFull','phoneLoveFull')?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">是</span>
								</div>
								<div @click="setRetf(layoutConfig.right.rightBtn,'loveFull','phoneLoveFull',false)"
									:style="{backgroundColor:!retf(layoutConfig.right.rightBtn,'loveFull','phoneLoveFull')?'#8c62ff':'#fff',color:!retf(layoutConfig.right.rightBtn,'loveFull','phoneLoveFull')?'#fff':'#000',border:!retf(layoutConfig.right.rightBtn,'loveFull','phoneLoveFull')?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">否</span>
								</div>
							</div>
						</div>

						<div v-if="equipment == 'phone'"
							style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>移动端位置</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.phoneBtnP = 'top'"
									:style="{backgroundColor:layoutConfig.right.phoneBtnP == 'top'?'#8c62ff':'#fff',color:layoutConfig.right.phoneBtnP == 'top'?'#fff':'#000',border:layoutConfig.right.phoneBtnP == 'top'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">置上</span>
								</div>
								<div @click="layoutConfig.right.phoneBtnP = 'bto'"
									:style="{backgroundColor:layoutConfig.right.phoneBtnP == 'bto'?'#8c62ff':'#fff',color:layoutConfig.right.phoneBtnP == 'bto'?'#fff':'#000',border:layoutConfig.right.phoneBtnP == 'bto'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">置下</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div style="width: 210px;border-top: solid 1px #d8d8d8 ;background-color: #F6F7F9;">
				<div style="max-width: 100%;margin: 6px;margin-top: 10px;">
					<div>购物按钮下自定义代码</div>
				</div>
				<el-input style="margin-bottom: 10px;" type="textarea" :rows="5" placeholder="请输入内容"
					v-model="layoutConfig.right.htmlCode">
				</el-input>
			</div>

			<div style="width: 235px;display: flex;flex-direction: column;align-items: center;font-size: 12px;">
				<div style="width: 210px;background-color: #F6F7F9;">
					<div style="height: 1px;background-color: #c7c7c7;width: 100%;"></div>
					<div style="width: 210px;padding: 6px;">
						<div style="margin-top: 10px;">
							<div>产品详情/属性/评论</div>
						</div>
						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>位置</div>

						</div>
						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div style="display: flex;align-items: center;justify-content: center;width: 100%;">
								<div @click="layoutConfig.right.titSet.position = '1'"
									:style="{backgroundColor:layoutConfig.right.titSet.position == '1'?'#8c62ff':'#fff',color:layoutConfig.right.titSet.position == '1'?'#fff':'#000',border:layoutConfig.right.titSet.position == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 4px;width: fit-content;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">默认</span>
								</div>
								<div @click="layoutConfig.right.titSet.position = '2'"
									:style="{backgroundColor:layoutConfig.right.titSet.position == '2'?'#8c62ff':'#fff',color:layoutConfig.right.titSet.position == '2'?'#fff':'#000',border:layoutConfig.right.titSet.position == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 4px;width: fit-content;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">主图下</span>
								</div>
								<div @click="layoutConfig.right.titSet.position = '3'"
									:style="{backgroundColor:layoutConfig.right.titSet.position == '3'?'#8c62ff':'#fff',color:layoutConfig.right.titSet.position == '3'?'#fff':'#000',border:layoutConfig.right.titSet.position == '3'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 4px;width: fit-content;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">购物按钮下</span>
								</div>
							</div>
						</div>


						<div style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>字体颜色</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.tabColor.titColor"></el-color-picker>
						</div>

						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								标题大小
							</div>
							<div style="display: flex;align-items: center;">
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.tabFontSize"
										@change="(e)=>{layoutConfig.right.tabFontSize = e}"></wm-input-number>
								</div>
							</div>
						</div>
						
						<div
							style="display: flex;align-items: center;margin-top: 6px;justify-content: space-between;width: 198px;">
							<div>
								标题间距
							</div>
							<div style="display: flex;align-items: center;">
								<div
									style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
									<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
										:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
										:value="layoutConfig.right.detailMl"
										@change="(e)=>{layoutConfig.right.detailMl = e}"></wm-input-number>
								</div>
							</div>
						</div>

						<div style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>标题未选中颜色</div>
							<el-color-picker size="mini"
								v-model="layoutConfig.right.tabColor.titNoSelectColor"></el-color-picker>
						</div>


						<div v-if="layoutConfig.right.detailModel != 'block' && layoutConfig.right.detailModel != 'accordion'"
							style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>标题背景</div>
							<div style="display: flex;align-items: center;margin-left:8px;">
								<div @click="layoutConfig.right.titSet.bg.bgtype = 'color'"
									:style="{backgroundColor:layoutConfig.right.titSet.bg.bgtype == 'color'?'#8c62ff':'#fff',color:layoutConfig.right.titSet.bg.bgtype == 'color'?'#fff':'#000',border:layoutConfig.right.titSet.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">纯色</span>
								</div>
								<div @click="layoutConfig.right.titSet.bg.bgtype = 'gradient'"
									:style="{backgroundColor:layoutConfig.right.titSet.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:layoutConfig.right.titSet.bg.bgtype == 'gradient'?'#fff':'#000',border:layoutConfig.right.titSet.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">渐变</span>
								</div>
							</div>
						</div>

						<div v-if="layoutConfig.right.detailModel != 'block'" style="width: 210px;">
							<div v-if="layoutConfig.right.titSet.bg.bgtype == 'color'"
								style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
								<div style="width: 68px;">
									背景颜色:
								</div>
								<el-color-picker size="mini"
									v-model="layoutConfig.right.titSet.bg.color"></el-color-picker>
							</div>
							<div v-if="layoutConfig.right.titSet.bg.bgtype == 'gradient'"
								style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
								<div
									style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
									<div style="display: flex;flex-direction: column;">
										<div style="display: flex;align-items: center;">
										</div>
										<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
											placeholder="请输入内容" v-model="layoutConfig.right.titSet.bg.bgGradient">
										</el-input>
									</div>
									<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
										需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
											href="https://www.eggradients.com/">Gradient1</a> <a
											style="margin-left: 4px;" target="_blank"
											href="https://webgradients.com/">Gradient2</a>
									</div>
								</div>
							</div>
						</div>


						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>产品详情</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showDetail = true"
									:style="{backgroundColor:layoutConfig.right.showDetail?'#8c62ff':'#fff',color:layoutConfig.right.showDetail?'#fff':'#000',border:layoutConfig.right.showDetail?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showDetail = false"
									:style="{backgroundColor:!layoutConfig.right.showDetail?'#8c62ff':'#fff',color:!layoutConfig.right.showDetail?'#fff':'#000',border:!layoutConfig.right.showDetail?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>
						<div style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>产品属性</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showAttr = true"
									:style="{backgroundColor:layoutConfig.right.showAttr?'#8c62ff':'#fff',color:layoutConfig.right.showAttr?'#fff':'#000',border:layoutConfig.right.showAttr?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showAttr = false"
									:style="{backgroundColor:!layoutConfig.right.showAttr?'#8c62ff':'#fff',color:!layoutConfig.right.showAttr?'#fff':'#000',border:!layoutConfig.right.showAttr?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>
						<div style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>产品评论</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.showComment = true"
									:style="{backgroundColor:layoutConfig.right.showComment?'#8c62ff':'#fff',color:layoutConfig.right.showComment?'#fff':'#000',border:layoutConfig.right.showComment?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">启用</span>
								</div>
								<div @click="layoutConfig.right.showComment = false"
									:style="{backgroundColor:!layoutConfig.right.showComment?'#8c62ff':'#fff',color:!layoutConfig.right.showComment?'#fff':'#000',border:!layoutConfig.right.showComment?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">隐藏</span>
								</div>
							</div>
						</div>

						<div>
							<div>排序</div>
							<div style="width: 210px; display: flex;flex-direction: column;align-items: center;">
								<draggable style="margin-top: 10px;" v-model="layoutConfig.right.titSet.sort"
									:group="{name: 'titset',pull:true,put:true,sort:true}" animation="500">
									<transition-group style="display: flex;flex-wrap: wrap;">
										<div style="padding: 4px 6px;border: solid 1px #d5d5d5 ;background-color: #8c62ff;color: #fff;"
											v-for="(item,index) in layoutConfig.right.titSet.sort" :key="index">
											<i class="el-icon-rank"></i>

											{{item.label}}
										</div>
									</transition-group>
								</draggable>
								<div style="margin-top: 4px;font-size: 12px;color: #7d7d7d ;">拖拽选项卡排序</div>
							</div>
						</div>

						<div style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>显示模式设置</div>
							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.detailModel = 'block'"
									:style="{backgroundColor:layoutConfig.right.detailModel == 'block'?'#8c62ff':'#fff',color:layoutConfig.right.detailModel == 'block'?'#fff':'#000',border:layoutConfig.right.detailModel == 'block'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">区块</span>
								</div>
								<div @click="layoutConfig.right.detailModel = 'label'"
									:style="{backgroundColor:layoutConfig.right.detailModel == 'label'?'#8c62ff':'#fff',color:layoutConfig.right.detailModel == 'label'?'#fff':'#000',border:layoutConfig.right.detailModel == 'label'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">标签</span>
								</div>
								<div @click="layoutConfig.right.detailModel = 'accordion'"
									:style="{backgroundColor:layoutConfig.right.detailModel == 'accordion'?'#8c62ff':'#fff',color:layoutConfig.right.detailModel == 'accordion'?'#fff':'#000',border:layoutConfig.right.detailModel == 'accordion'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">手风琴</span>
								</div>
							</div>
						</div>
						<div style="display: flex;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div>边框设置</div>

							<div style="display: flex;align-items: center;">
								<div @click="layoutConfig.right.detailBorderType = ''"
									:style="{backgroundColor:layoutConfig.right.detailBorderType == ''?'#8c62ff':'#fff',color:layoutConfig.right.detailBorderType == ''?'#fff':'#000',border:layoutConfig.right.detailBorderType == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">无</span>
								</div>
								<div @click="layoutConfig.right.detailBorderType = 'solid'"
									:style="{backgroundColor:layoutConfig.right.detailBorderType == 'solid'?'#8c62ff':'#fff',color:layoutConfig.right.detailBorderType == 'solid'?'#fff':'#000',border:layoutConfig.right.detailBorderType == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">实线</span>
								</div>
								<div @click="layoutConfig.right.detailBorderType = 'dashed'"
									:style="{backgroundColor:layoutConfig.right.detailBorderType == 'dashed'?'#8c62ff':'#fff',color:layoutConfig.right.detailBorderType == 'dashed'?'#fff':'#000',border:layoutConfig.right.detailBorderType == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">虚线</span>
								</div>
							</div>
						</div>
						<div
							style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;width: 198px;">
							<div> </div>
							<div
								style="display: flex;align-items: center;margin-left:8px;background-color: #fff;padding: 2px 4px;">
								<el-color-picker size="small"
									v-model="layoutConfig.right.detailBorderColor"></el-color-picker>
								<el-input style="width: 84px;margin-left: 6px;" size="mini" placeholder=""
									v-model="layoutConfig.right.detailBorderColor" :disabled="true">
								</el-input>
							</div>
						</div>
						<div style="margin-top: 10px;">
							<div>线条大小</div>
							<div
								style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="changeDetailBorderSize"
										v-model="layoutConfig.right.detailBorderSize[0]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="changeDetailBorderSize"
										v-model="layoutConfig.right.detailBorderSize[1]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="changeDetailBorderSize"
										v-model="layoutConfig.right.detailBorderSize[2]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;color: #424242;scale: 0.85;">底部</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<input @input="changeDetailBorderSize"
										v-model="layoutConfig.right.detailBorderSize[3]"
										style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
									<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧</div>
								</div>
								<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
									<i @click="detailBorderSizeAll = !detailBorderSizeAll"
										:style="{color:detailBorderSizeAll?'#8c62ff':'#000'}"
										style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
										class="el-icon-paperclip tit-icon"></i>
								</div>
							</div>
						</div>



						<div style="display: flex;justify-content: space-between;margin-top: 15px;width: 198px;">
							<div>背景设置</div>
							<div style="display: flex;align-items: center;margin-left:8px;">
								<div @click="layoutConfig.bto.bgType = '1'"
									:style="{backgroundColor:layoutConfig.bto.bgType == '1'?'#8c62ff':'#fff',color:layoutConfig.bto.bgType == '1'?'#fff':'#000',border:layoutConfig.bto.bgType == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">纯色</span>
								</div>
								<div @click="layoutConfig.bto.bgType = '2'"
									:style="{backgroundColor:layoutConfig.bto.bgType == '2'?'#8c62ff':'#fff',color:layoutConfig.bto.bgType == '2'?'#fff':'#000',border:layoutConfig.bto.bgType == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">渐变</span>
								</div>
								<div @click="layoutConfig.bto.bgType = '3'"
									:style="{backgroundColor:layoutConfig.bto.bgType == '3'?'#8c62ff':'#fff',color:layoutConfig.bto.bgType == '3'?'#fff':'#000',border:layoutConfig.bto.bgType == '3'?'solid 1px #8c62ff':'solid 1px #959595' }"
									style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
									<span style="scale: 0.85;">图片</span>
								</div>
							</div>
						</div>

						<div style="width: 210px;">
							<div v-if="layoutConfig.bto.bgType == '1'"
								style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
								<div style="width: 68px;">
									背景颜色:
								</div>
								<el-color-picker size="mini" v-model="layoutConfig.bto.singleBgColor"></el-color-picker>
							</div>
							<div v-if="layoutConfig.bto.bgType == '2'"
								style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
								<div
									style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
									<div style="display: flex;flex-direction: column;">
										<div style="display: flex;align-items: center;">
										</div>
										<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
											placeholder="请输入内容" v-model="layoutConfig.bto.bgColor">
										</el-input>
									</div>
									<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
										需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
											href="https://www.eggradients.com/">Gradient1</a> <a
											style="margin-left: 4px;" target="_blank"
											href="https://webgradients.com/">Gradient2</a>
									</div>
								</div>
							</div>

							<div v-if="layoutConfig.bto.bgType == '3'"
								style="display: flex;justify-content: center;margin-top: 10px;width: 235px;font-size: 12px;">
								<div
									style="display: flex;align-items: center;background-color: #F6F7F9;height: 38px;justify-content: space-around;">
									<div style="font-size: 12px;margin-right: 4px;">
										背景图片
									</div>
									<div @click="selectBgImg"
										style="height: 30px;width: 30px;background-color: #fff;display: flex;align-items: center;justify-content: center;margin-left: 4px;">
										<el-image :src="layoutConfig.bto.bgImg" style="cursor: pointer;">
											<div slot="error" class="image-slot">
												<i style="font-size: 16px;" class="el-icon-plus"></i>
											</div>
										</el-image>
									</div>
									<el-select size="mini" style="width: 80px;margin-left: 4px;"
										v-model="layoutConfig.bto.bgImgType" filterable allow-create
										default-first-option placeholder="渲染方式">
										<el-option label="重复" value="repeat">
										</el-option>
										<el-option label="x轴重复" value="repeat-x">
										</el-option>
										<el-option label="y轴重复" value="repeat-y">
										</el-option>
										<el-option label="平铺" value="">
										</el-option>
										<el-option label="不平铺" value="no-repeat">
										</el-option>
									</el-select>
								</div>
							</div>
							<div v-if="layoutConfig.bto.bgType == '3'" style="display: flex;justify-content: center;">
								<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
									<div style="width: 40px;">
										宽度:
									</div>
									<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
										:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1"
										:max="10000000000" :value="layoutConfig.bto.bgWidth"
										@change="(e)=>{layoutConfig.bto.bgWidth = e}"></wm-input-number>
								</div>
							</div>
							<div v-if="layoutConfig.bto.bgType == '3'" style="display: flex;justify-content: center;">
								<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
									<div style="width: 40px;">
										高度:
									</div>
									<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
										:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1"
										:max="10000000000" :value="layoutConfig.bto.bgHeight"
										@change="(e)=>{layoutConfig.bto.bgHeight = e}"></wm-input-number>
								</div>
							</div>

							<div v-if="layoutConfig.bto.bgType == '3'"
								style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
								<div>
									背景位置
								</div>
								<el-select @change="(e)=>{layoutConfig.bto.bgPosition = e}"
									style="margin-left: 10px;width: 120px;" v-model="layoutConfig.bto.bgPosition"
									filterable allow-create default-first-option placeholder="图片位置">
									<el-option label="左上方" value="top left">
									</el-option>
									<el-option label="上中间" value="top center">
									</el-option>
									<el-option label="右上方" value="top right">
									</el-option>
									<el-option label="左中方" value="center left">
									</el-option>
									<el-option label="居中" value="center center">
									</el-option>
									<el-option label="右中方" value="center right">
									</el-option>
									<el-option label="下左方" value="bottom left">
									</el-option>
									<el-option label="下居中" value="bottom center">
									</el-option>
									<el-option label="下右方" value="bottom right">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<!-- <el-collapse v-model="activeNames" @change="handleChange">
			<el-collapse-item title="左半部" name="left">
				<template slot="title">
					<div style="font-size: 12px;padding: 0px 6px;padding-left: 10px;">
						左半部
					</div>
				</template>
				<div style="font-size: 12px;">
					<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
						<div
							style="height: 34px;background-color: #F6F7F9;width: 210px;display: flex;align-items: center;justify-content: space-around;">
							<div>
								布局
							</div>
							<div
								style="display: flex;align-items: center;width: 160px;justify-content: space-between;height: 34px;">
								<div @click="layoutConfig.left.layout = 'start'"
									:style="{border: layoutConfig.left.layout == 'start'?'#8c62ff 2px dashed':''}"
									style=";padding: 1px;border-radius: 4px;height: 20px;width: 20px;">
									<img style="height: 20px;width: 20px;" src="../img/left.png" />
								</div>
								<div @click="layoutConfig.left.layout = 'center'"
									:style="{border: layoutConfig.left.layout == 'center'?'#8c62ff 2px dashed':''}"
									style=";padding: 1px;border-radius: 4px;height: 20px;width: 20px;">
									<img style="height: 20px;width: 20px;" src="../img/cnter.png" />
								</div>
								<div @click="layoutConfig.left.layout = 'end'"
									:style="{border: layoutConfig.left.layout == 'end'?'#8c62ff 2px dashed':''}"
									style=";padding: 1px;border-radius: 4px;height: 20px;width: 20px;">
									<img style="height: 20px;width: 20px;" src="../img/right.png" />
								</div>
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 15px;">
						<div
							style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;">
							<div style="width: 60px;margin: 4px;">
								宽度占比:
							</div>
							<wm-input-number :iptWidth="80" :disabled="false"
								:styleObj="{width: '150px',height: '30px'}" :step="1" :min="1" :max="100"
								:value="layoutConfig.left.width"
								@change="(e)=>{changeWidth(e,layoutConfig)}"></wm-input-number>
						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 15px;">
						<div style="width: 210px;background-color: #F6F7F9;">
							<div style="width: 100px;margin: 4px;">
								预览图
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;">
								图片宽度
								<wm-input-number style="margin-left: 10px;" :iptWidth="100" :disabled="false"
									:styleObj="{width: '120px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.left.preViewImgWidth"
									@change="(e)=>{layoutConfig.left.preViewImgWidth = e}"></wm-input-number>
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;">
								图片高度
								<wm-input-number style="margin-left: 10px;" :iptWidth="100" :disabled="false"
									:styleObj="{width: '120px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.left.preViewImgHeight"
									@change="(e)=>{layoutConfig.left.preViewImgHeight = e}"></wm-input-number>
							</div>

						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 15px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="width: 100px;margin: 4px;">
								预览图列表
							</div>
							<div style="margin: 4px;margin-top: 15px;">
								位置
								<el-select size="mini" style="height: 32px;width: 100px;margin-left: 10px;"
									v-model="layoutConfig.left.preViewListPosition" placeholder="请选择位置">
									<el-option label="居左" value="left">
									</el-option>
									<el-option label="居上" value="top">
									</el-option>
									<el-option label="居右" value="right">
									</el-option>
									<el-option label="居下" value="bottom">
									</el-option>
								</el-select>
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;">
								宽度
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '150px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.left.preViewListImgWidth"
									@change="(e)=>{layoutConfig.left.preViewListImgWidth = e}"></wm-input-number>
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;">
								高度
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '150px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.left.preViewListImgHeight"
									@change="(e)=>{layoutConfig.left.preViewListImgHeight = e}"></wm-input-number>
							</div>
						</div>
					</div>
				</div>
			</el-collapse-item>
			<el-collapse-item title="右半部" name="right">
				<template slot="title">
					<div style="font-size: 12px;padding: 0px 6px;padding-left: 10px;">
						右半部
					</div>
				</template>
				<div style="font-size: 12px;">
					<div style="display: flex;justify-content: center;">
						<div
							style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;">
							<div style="width: 60px;padding-left: 4px;">
								宽度占比:
							</div>
							<wm-input-number :iptWidth="80" :disabled="false"
								:styleObj="{width: '150px',height: '30px'}" :step="1" :min="1" :max="100"
								:value="layoutConfig.right.width"
								@change="(e)=>{changeRightWidth(e,layoutConfig)}"></wm-input-number>
						</div>
					</div>

					<div style="display: flex;justify-content: center;margin-top: 15px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="padding-left: 4px;">
								标题
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体大小:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.titleSize"
									@change="(e)=>{layoutConfig.right.titleSize = e}"></wm-input-number>
							</div>

							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体颜色:
								</div>
								<el-color-picker size="mini" v-model="layoutConfig.right.titleColor"></el-color-picker>
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体粗细:
								</div>
								<el-select size="mini" style="width: 80px;" v-model="layoutConfig.right.titleBold"
									placeholder="">
									<el-option v-for="item in fontOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>

					<div style="display: flex;justify-content: center;margin-top: 10px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="padding-left: 4px;">
								价格
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体大小:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.priceSize"
									@change="(e)=>{layoutConfig.right.priceSize = e}"></wm-input-number>
							</div>

							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体颜色:
								</div>
								<el-color-picker size="mini" v-model="layoutConfig.right.priceColor"></el-color-picker>
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体粗细:
								</div>
								<el-select size="mini" style="width: 80px;" v-model="layoutConfig.right.priceBold"
									placeholder="">
									<el-option v-for="item in fontOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>

					<div style="display: flex;justify-content: center;margin-top: 10px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="padding-left: 4px;">
								折扣价格
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体大小:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.discountSize"
									@change="(e)=>{layoutConfig.right.discountSize = e}"></wm-input-number>
							</div>

							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体颜色:
								</div>
								<el-color-picker size="mini"
									v-model="layoutConfig.right.discountColor"></el-color-picker>
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体粗细:
								</div>
								<el-select size="mini" style="width: 80px;" v-model="layoutConfig.right.discountBold"
									placeholder="">
									<el-option v-for="item in fontOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 10px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="padding-left: 4px;">
								库存
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体大小:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.InventorySize"
									@change="(e)=>{layoutConfig.right.InventorySize = e}"></wm-input-number>
							</div>

							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体颜色:
								</div>
								<el-color-picker size="mini"
									v-model="layoutConfig.right.InventoryColor"></el-color-picker>
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 10px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="padding-left: 4px;">
								品牌
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体大小:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.brandSize"
									@change="(e)=>{layoutConfig.right.brandSize = e}"></wm-input-number>
							</div>

							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体颜色:
								</div>
								<el-color-picker size="mini" v-model="layoutConfig.right.brandColor"></el-color-picker>
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 10px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="padding-left: 4px;">
								SKU
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体大小:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.skuSize"
									@change="(e)=>{layoutConfig.right.skuSize = e}"></wm-input-number>
							</div>

							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体颜色:
								</div>
								<el-color-picker size="mini" v-model="layoutConfig.right.skuColor"></el-color-picker>
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 10px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="padding-left: 4px;">
								型号
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体大小:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.sSize"
									@change="(e)=>{layoutConfig.right.sSize = e}"></wm-input-number>
							</div>

							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体颜色:
								</div>
								<el-color-picker size="mini" v-model="layoutConfig.right.sColor"></el-color-picker>
							</div>
						</div>
					</div>

					<div style="display: flex;justify-content: center;margin-top: 10px;">
						<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
							<div style="padding-left: 4px;">
								规格
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体大小:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.right.specSize"
									@change="(e)=>{layoutConfig.right.specSize = e}"></wm-input-number>
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									边框颜色:
								</div>
								<el-color-picker size="mini" v-model="layoutConfig.right.specsBorder"></el-color-picker>
							</div>
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 80px;">
									字体颜色:
								</div>
								<el-color-picker size="mini" v-model="layoutConfig.right.specsColor"></el-color-picker>
							</div>
						</div>
					</div>
				</div>
			</el-collapse-item>
			<el-collapse-item title="商品属性 / 详情" name="bto">
				<template slot="title">
					<div style="font-size: 12px;padding: 0px 6px;padding-left: 10px;">
						商品属性 / 详情
					</div>
				</template>
				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div style="display: flex;align-items: center;">
						<div @click="layoutConfig.bto.widthType = 'percentage'"
							:style="{backgroundColor:layoutConfig.bto.widthType == 'percentage'?'#605bf6':'#fff',color:layoutConfig.bto.widthType == 'percentage'?'#fff':'#000'}"
							style="border: solid 1px #d1d1d1 ;padding: 4px 6px;width: 80px;text-align: center;cursor: pointer;">
							全宽
						</div>
						<div :style="{backgroundColor:layoutConfig.bto.widthType == 'px'?'#605bf6':'#fff',color:layoutConfig.bto.widthType == 'px'?'#fff':'#000'}"
							@click="layoutConfig.bto.widthType = 'px'"
							style="border: solid 1px #d1d1d1 ;padding: 4px 6px;width: 80px;text-align: center;cursor: pointer;">
							盒装
						</div>
					</div>
				</div>

				<div v-if="layoutConfig.bto.widthType == 'px'"
					style="display: flex;justify-content: center;margin-top: 10px;">
					<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
						<div style="display: flex;align-items: center;padding-left: 4px;">
							<div style="width: 80px;">
								盒装宽度:
							</div>
							<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
								:styleObj="{width: '130px',height: '30px'}" :step="1" :min="1" :max="10000000000"
								:value="layoutConfig.bto.width"
								@change="(e)=>{layoutConfig.bto.width = e}"></wm-input-number>
						</div>
					</div>
				</div>


				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div style="width: 210px;background-color: #F6F7F9;margin: 4px;">
						<div style="padding-left: 4px;">
							背景
						</div>
						<div
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;width: 100%;justify-content: space-around;">
							<div @click="layoutConfig.bto.bgType = '1'">
								<el-checkbox :value="layoutConfig.bto.bgType == '1'">纯色</el-checkbox>
							</div>
							<div @click="layoutConfig.bto.bgType = '2'" style="margin-left: 5;">
								<el-checkbox :value="layoutConfig.bto.bgType == '2'">渐变</el-checkbox>
							</div>
							<div @click="layoutConfig.bto.bgType = '3'" style="margin-left: 5;">
								<el-checkbox :value="layoutConfig.bto.bgType == '3'">图片</el-checkbox>
							</div>
						</div>

						<div v-if="layoutConfig.bto.bgType == '1'"
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
							<div style="width: 40px;">
								颜色:
							</div>
							<el-color-picker size="mini" v-model="layoutConfig.bto.singleBgColor"></el-color-picker>
						</div>
						<div v-if="layoutConfig.bto.bgType == '2'"
							style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
							<div
								style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
								<div style="display: flex;flex-direction: column;">
									<div style="display: flex;align-items: center;">
										<div :style="layoutConfig.bto.bgColor"
											style="width: 20px;height: 20px;border: 1px solid #cacaca;border-radius: 4px;">
										</div>
										<el-select size="mini" clearable @change="(e)=>{
											layoutConfig.bto.bgColor = e
										}" style="width: 146px;margin-left: 2px;" v-model="layoutConfig.bto.type" filterable allow-create
											default-first-option placeholder="模板选择">
											<el-option style="color: #000000;" :style="item.value" :id="'op' + index"
												v-for="(item,index) in bgOptions" :key="index" :label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
									</div>
									<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
										placeholder="请输入内容" v-model="layoutConfig.bto.bgColor">
									</el-input>
								</div>
								<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
									需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
										href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
										target="_blank" href="https://webgradients.com/">Gradient2</a>
								</div>
							</div>
						</div>

						<div v-if="layoutConfig.bto.bgType == '3'"
							style="display: flex;justify-content: center;margin-top: 10px;width: 235px;font-size: 12px;">
							<div
								style="display: flex;align-items: center;background-color: #F6F7F9;height: 38px;width: 210px;justify-content: space-around;">
								<div style="font-size: 12px;">
									背景图片
								</div>
								<div @click="selectBgImg"
									style="height: 30px;width: 30px;background-color: #fff;display: flex;align-items: center;justify-content: center;">
									<el-image :src="layoutConfig.bto.bgImg" style="cursor: pointer;">
										<div slot="error" class="image-slot">
											<i style="font-size: 16px;" class="el-icon-plus"></i>
										</div>
									</el-image>
								</div>
								<el-select size="mini" style="width: 84px;" v-model="layoutConfig.bto.bgImgType"
									filterable allow-create default-first-option placeholder="渲染方式">
									<el-option label="重复" value="repeat">
									</el-option>
									<el-option label="x轴重复" value="repeat-x">
									</el-option>
									<el-option label="y轴重复" value="repeat-y">
									</el-option>
									<el-option label="平铺" value="">
									</el-option>
									<el-option label="不平铺" value="no-repeat">
									</el-option>
								</el-select>
							</div>
						</div>
						<div v-if="layoutConfig.bto.bgType == '3'" style="display: flex;justify-content: center;">
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 40px;">
									宽度:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.bto.bgWidth"
									@change="(e)=>{layoutConfig.bto.bgWidth = e}"></wm-input-number>
							</div>
						</div>
						<div v-if="layoutConfig.bto.bgType == '3'" style="display: flex;justify-content: center;">
							<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
								<div style="width: 40px;">
									高度:
								</div>
								<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
									:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1" :max="10000000000"
									:value="layoutConfig.bto.bgHeight"
									@change="(e)=>{layoutConfig.bto.bgHeight = e}"></wm-input-number>
							</div>
						</div>

						<div v-if="layoutConfig.bto.bgType == '3'"
							style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
							<div>
								背景位置
							</div>
							<el-select @change="(e)=>{layoutConfig.bto.bgPosition = e}"
								style="margin-left: 10px;width: 120px;" v-model="layoutConfig.bto.bgPosition" filterable
								allow-create default-first-option placeholder="图片位置">
								<el-option label="左上方" value="top left">
								</el-option>
								<el-option label="上中间" value="top center">
								</el-option>
								<el-option label="右上方" value="top right">
								</el-option>
								<el-option label="左中方" value="center left">
								</el-option>
								<el-option label="居中" value="center center">
								</el-option>
								<el-option label="右中方" value="center right">
								</el-option>
								<el-option label="下左方" value="bottom left">
								</el-option>
								<el-option label="下居中" value="bottom center">
								</el-option>
								<el-option label="下右方" value="bottom right">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</el-collapse-item>
		</el-collapse> -->

		<el-dialog :modal="false" custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisible" width="80%"
			:before-close="()=>{dialogVisible = false}">
			<select-img style="height: 70vh" @confirmImg="confirmImg" v-if="dialogVisible"></select-img>
		</el-dialog>
	</div>
</template>
<script>
	import selectPage from '../cpm/selectPage.vue'
	import wmInputNumber from '../components/inputNumber.vue'
	import selectImg from '../components/selectImg.vue'
	import draggable from 'vuedraggable'
	import {
		getProductsAutocomplete,
		l_commentComments
	} from '../../api/all.js'
	export default {
		components: {
			wmInputNumber,
			selectPage,
			selectImg,
			draggable
		},
		props: {
			all_setting: {
				type: Array,
				default: []
			},
			fontList: {
				type: Array,
				default: []
			},
			equipment: {
				type: String,
				default: "pc"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		watch: {
			selectdItem: {
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					this.layoutConfig = newVal.compontChildren[0].layoutConfig

				}
			},
			equipment: {
				handler: function(newVal, oldVal) {
					this.mainImgSetType = newVal
					this.affiliatedImgType = newVal
				}
			}
		},
		data() {
			return {
				selectImgBorderRadiusAll:true,
				borderAffiliatedRadiusAll: true,
				detailBorderSizeAll: true,
				optionBorderRadiusAll: true,
				optionBorderSizeAll: true,
				affiliatedImgType: 'pc', // pc phone
				mainImgSetType: "pc", // pc phone
				borderAffiliatedSizeAll: true,
				boderAffiliatedRadiusAll: true,
				borderSizeAll: true,
				boderRadiusAll: true,
				value: '',
				dataOptins: [],
				loading: false,
				dialogVisible: false,
				bgOptions: [{

						label: "模板1",
						value: 'background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%);'
					},
					{

						label: "模板2",
						value: 'background: rgb(30,144,255);background: linear-gradient(159deg, rgba(30,144,255,1) 0%, rgba(153,186,221,1) 100%);'
					},
					{

						label: "模板3",
						value: 'background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%);'
					},
					{

						label: "模板4",
						value: 'background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%);'
					},
					{

						label: "模板5",
						value: 'background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%);'
					},
				],
				layoutConfig: {},
				activeNames: "",
				fontOptions: [{
						label: '无',
						value: 'none'
					},
					{
						label: '100',
						value: '100',
					},
					{
						label: '200',
						value: '200',
					},
					{
						label: '300',
						value: '300',
					},
					{
						label: '400',
						value: '400',
					},
					{
						label: '500',
						value: '500',
					},
					{
						label: '600',
						value: '600',
					},
					{
						label: '700',
						value: '700',
					},
					{
						label: '800',
						value: '800',
					},
					{
						label: '900',
						value: '900',
					},
					{
						label: '加粗',
						value: 'bold',
					}
				],
			}
		},
		computed: {
			systemFontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			}
		},



		async mounted() {
			// await this.getData()
			if (!this.layoutConfig.right.phoneBtnP) {
				this.$set(this.layoutConfig.right, 'phoneBtnP', 'top')
			}
			
			if (!this.layoutConfig.right.detailMl) {
				this.$set(this.layoutConfig.right, 'detailMl', 5)
			}
			
			if (!this.layoutConfig.right.showSelectImg) {
				this.$set(this.layoutConfig.right, 'showSelectImg', false)
			}
			
			if (!this.layoutConfig.right.showSelectImgSet) {
				this.$set(this.layoutConfig.right, 'showSelectImgSet', {
					width:60,
					height:60,
					phoneWidth:40,
					phoneHeight:40,
					mode:'cover'
				})
			}
			
			if (!this.layoutConfig.right.selectImgBorderRadius) {
				this.$set(this.layoutConfig.right, 'selectImgBorderRadius', [0,0,0,0])
			}
			
			
			

			if (!this.layoutConfig.right.selectTabSet) {
				this.$set(this.layoutConfig.right, 'selectTabSet', {
					hoverBg: {
						fontColor: "#000",
						bgtype: "color", // color gradient img
						bgGradient: "",
						color: "#fff",
					},
					selectBg: {
						fontColor: "#000",
						bgtype: "color", // color gradient img
						bgGradient: "",
						color: "#fff",
					},
					defaultBg: {
						fontColor: "#595959",
						bgtype: "color", // color gradient img
						bgGradient: "",
						color: "#fff",
					}

				})
			}

			if (!this.layoutConfig.right.priceShow) {
				this.$set(this.layoutConfig.right, 'priceShow', {
					price: true,
					originalPrice: true
				})
			}

			if (!this.layoutConfig.right.rightBtn) {
				this.$set(this.layoutConfig.right, 'rightBtn', {
					addNumFull: false,
					addCartFull: false,
					buyNowFull: false,
					loveFull: false,
					addCartWidth: 160,
					buyNowWidth: 160,
					phoneAddNumFull: false,
					phoneAddCartFull: false,
					phoneBuyNowFull: false,
					phoneLoveFull: false,
					phoneAddCartWidth: 105,
					phoneBuyNowWidth: 105,
				})
			}

			if (!this.layoutConfig.right.rightBtnColor) {
				this.$set(this.layoutConfig.right, 'rightBtnColor', {
					addCart: {
						color: "#000",
						bg: {
							bgtype: "color", // color gradient img
							bgGradient: "",
							color: "#fff",
						},
						border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: "#000"
						},
					},
					buyNow: {
						color: "#fff",
						bg: {
							bgtype: "color", // color gradient img
							bgGradient: "",
							color: "#000",
						},
						border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: "#000"
						},
					},
					love: {
						bg: {
							color: "#000",
						},
					}
				})
			}

			if (!this.layoutConfig.right.tabColor) {
				this.$set(this.layoutConfig.right, 'tabColor', {
					titColor: "#000",
					titNoSelectColor: "#888888"
				})

			}

			if (!this.layoutConfig.right.tabFontSize) {
				this.$set(this.layoutConfig.right, 'tabFontSize', 16)
			}


			if (!this.layoutConfig.right.quantityFont) {
				this.$set(this.layoutConfig.right, 'quantityFont', {
					color: "#a3a3a3",
					fontSize: 16,
					fontFamily: "",
					titColor: "#000",
					titFontSize: 16,
					titFontFamily: ""
				})

			}
			if (!this.layoutConfig.right.brandFont) {
				this.$set(this.layoutConfig.right, 'brandFont', {
					color: "#a3a3a3",
					fontSize: 16,
					fontFamily: "",
					titColor: "#000",
					titFontSize: 16,
					titFontFamily: ""
				})
			}
			if (!this.layoutConfig.right.skuFont) {
				this.$set(this.layoutConfig.right, 'skuFont', {
					color: "#a3a3a3",
					fontSize: 16,
					fontFamily: "",
					titColor: "#000",
					titFontSize: 16,
					titFontFamily: ""
				})
			}
			if (!this.layoutConfig.right.modelFont) {
				this.$set(this.layoutConfig.right, 'modelFont', {
					color: "#a3a3a3",
					fontSize: 16,
					fontFamily: "",
					titColor: "#000",
					titFontSize: 16,
					titFontFamily: ""
				})
			}

			if (!this.layoutConfig.right.htmlCode) {
				this.$set(this.layoutConfig.right, 'htmlCode', '')
			}

			if (!this.layoutConfig.right.titSet) {
				this.$set(this.layoutConfig.right, 'titSet', {
					bg: {
						bgtype: "color", // color gradient img
						bgGradient: "",
						color: "",
					},
					sort: [{
							value: 'detail',
							label: "详情"
						},
						{
							value: 'attr',
							label: "属性"
						},
						{
							value: 'coment',
							label: "评论"
						}
					],
					position: "1",
					padding: [0, 0, 0, 0]
				})
			} else {
				// delete this.layoutConfig.right["titSet"]
			}

			this.mainImgSetType = this.equipment
			this.affiliatedImgType = this.equipment
			let font = this.layoutConfig.right
			font.titleFontFamily = font.titleFontFamily != '' ? font.titleFontFamily : this.systemFontFamilyName
			font.priceFontFamily = font.priceFontFamily != '' ? font.priceFontFamily : this.systemFontFamilyName
			font.discountFamily = font.discountFamily != '' ? font.discountFamily : this.systemFontFamilyName
			font.optionFamily = font.optionFamily != '' ? font.optionFamily : this.systemFontFamilyName
		},
		methods: {
			setRetf(item, filed1, filed2, bool = true) {
				if (this.equipment == 'pc') {
					item[filed1] = bool
				} else {
					item[filed2] = bool
				}
			},
			retf(item, filed1, filed2) {
				if (this.equipment == 'pc') {
					return item[filed1]
				} else {
					return item[filed2]
				}
			},
			changeDetailBorderSize(e) {
				if (this.detailBorderSizeAll) {
					this.layoutConfig.right.detailBorderSize = []
					this.layoutConfig.right.detailBorderSize.push(e.target.value)
					this.layoutConfig.right.detailBorderSize.push(e.target.value)
					this.layoutConfig.right.detailBorderSize.push(e.target.value)
					this.layoutConfig.right.detailBorderSize.push(e.target.value)
				}
			},
			changeoptionBorderSize(e) {
				if (this.optionBorderSizeAll) {
					this.layoutConfig.right.optionBorderSize = []
					this.layoutConfig.right.optionBorderSize.push(e.target.value)
					this.layoutConfig.right.optionBorderSize.push(e.target.value)
					this.layoutConfig.right.optionBorderSize.push(e.target.value)
					this.layoutConfig.right.optionBorderSize.push(e.target.value)
				}
			},
			changeoptionImgBorderRadius(e){
				if (this.selectImgBorderRadiusAll) {
					this.layoutConfig.right.selectImgBorderRadius = []
					this.layoutConfig.right.selectImgBorderRadius.push(e.target.value)
					this.layoutConfig.right.selectImgBorderRadius.push(e.target.value)
					this.layoutConfig.right.selectImgBorderRadius.push(e.target.value)
					this.layoutConfig.right.selectImgBorderRadius.push(e.target.value)
				}
			},
			changeoptionBorderRadius(e) {
				if (this.optionBorderRadiusAll) {
					this.layoutConfig.right.optionBorderRadius = []
					this.layoutConfig.right.optionBorderRadius.push(e.target.value)
					this.layoutConfig.right.optionBorderRadius.push(e.target.value)
					this.layoutConfig.right.optionBorderRadius.push(e.target.value)
					this.layoutConfig.right.optionBorderRadius.push(e.target.value)
				}
			},


			changeAffiliatedSize(e) {
				if (this.borderAffiliatedSizeAll) {
					this.layoutConfig.left.borderAffiliatedSize = []
					this.layoutConfig.left.borderAffiliatedSize.push(e.target.value)
					this.layoutConfig.left.borderAffiliatedSize.push(e.target.value)
					this.layoutConfig.left.borderAffiliatedSize.push(e.target.value)
					this.layoutConfig.left.borderAffiliatedSize.push(e.target.value)
				}
			},
			changeAffiliatedRadius(e) {
				if (this.boderAffiliatedRadiusAll) {
					this.layoutConfig.left.borderAffiliatedRadius = []
					this.layoutConfig.left.borderAffiliatedRadius.push(e.target.value)
					this.layoutConfig.left.borderAffiliatedRadius.push(e.target.value)
					this.layoutConfig.left.borderAffiliatedRadius.push(e.target.value)
					this.layoutConfig.left.borderAffiliatedRadius.push(e.target.value)
				}
			},


			changeMainWidth(e) {
				if (this.mainImgSetType == 'all') {
					this.layoutConfig.left.preViewImgWidth = e
					this.layoutConfig.left.preViewImgPhoneWidth = e
					return
				}
				if (this.mainImgSetType != 'phone') {
					this.layoutConfig.left.preViewImgWidth = e
				} else {
					this.layoutConfig.left.preViewImgPhoneWidth = e
				}
			},
			changeMainHeight(e) {
				if (this.mainImgSetType == 'all') {
					this.layoutConfig.left.preViewImgHeight = e
					this.layoutConfig.left.preViewImgPhoneHeight = e
					return
				}
				if (this.mainImgSetType != 'phone') {
					this.layoutConfig.left.preViewImgHeight = e
				} else {
					this.layoutConfig.left.preViewImgPhoneHeight = e
				}
			},

			changeAffiliatedWidth(e) {
				if (this.affiliatedImgType == 'all') {
					this.layoutConfig.left.preViewListImgWidth = e
					this.layoutConfig.left.preViewListImgPhoneWidth = e
					return
				}
				if (this.affiliatedImgType != 'phone') {
					this.layoutConfig.left.preViewListImgWidth = e
				} else {
					this.layoutConfig.left.preViewListImgPhoneWidth = e
				}
			},
			changeAffiliatedHeight(e) {
				if (this.affiliatedImgType == 'all') {
					this.layoutConfig.left.preViewListImgHeight = e
					this.layoutConfig.left.preViewListImgPhoneHeight = e
					return
				}
				if (this.affiliatedImgType != 'phone') {
					this.layoutConfig.left.preViewListImgHeight = e
				} else {
					this.layoutConfig.left.preViewListImgPhoneHeight = e
				}
			},


			changeRadius(e) {
				if (this.boderRadiusAll) {
					this.layoutConfig.left.borderRadius = []
					this.layoutConfig.left.borderRadius.push(e.target.value)
					this.layoutConfig.left.borderRadius.push(e.target.value)
					this.layoutConfig.left.borderRadius.push(e.target.value)
					this.layoutConfig.left.borderRadius.push(e.target.value)
				}
			},
			changeSize(e) {
				if (this.borderSizeAll) {
					this.layoutConfig.left.borderSize = []
					this.layoutConfig.left.borderSize.push(e.target.value)
					this.layoutConfig.left.borderSize.push(e.target.value)
					this.layoutConfig.left.borderSize.push(e.target.value)
					this.layoutConfig.left.borderSize.push(e.target.value)
				}
			},
			selectGoods(e) {
				console.log('e', e)
				// this.selectdItem.data.designGoodsId = e
				// console.log('selectdItem',this.selectdItem)
				// let selectItem;
				// this.dataOptins.forEach(item=>{
				// 	if(item.id == e) {
				// 		selectItem = item
				// 	}
				// })
				// if(selectItem) {
				// 	console.log('selectItem',selectItem)
				// }
			},
			async getData(name = '') {
				try {
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getProductsAutocomplete({
						wsid,
						name
					})
					this.dataOptins = data.data.data
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			},
			async remoteMethod(query) {
				console.log('query', query)
				try {
					if (query !== '') {
						this.loading = true;
						await this.getData(query)
					} else {
						// this.dataOptins = [];
					}
				} catch (e) {

				}

			},

			changeRightWidth(e, layoutConfig) {
				console.log('e,layoutConfig', e, layoutConfig)
				if (e > 100) {
					this.$message.error("最大值为100%")
					return
				}
				layoutConfig.right.width = e
				layoutConfig.left.width = 100 - e
			},
			changeWidth(e, layoutConfig) {
				console.log('e,layoutConfig', e, layoutConfig)
				if (e > 100) {
					this.$message.error("最大值为100%")
					return
				}
				layoutConfig.left.width = e
				layoutConfig.right.width = 100 - e
			},
			confirmImg(e) {
				console.log('e', e)
				this.dialogVisible = false
				this.layoutConfig.bto.bgImg = e.url
			},
			selectBgImg() {
				this.dialogVisible = true
			},
			handleChange() {

			}
		}
	}
</script>

<style scoped>
	.tit-icon:hover {
		color: #8c62ff;
	}

	.tit:hover {
		border: solid 1px #242754;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}
</style>